var items = {
  "block.minecraft.acacia_button": "Терностручова кнопка",
  "block.minecraft.acacia_door": "Терностручові двери",
  "block.minecraft.acacia_fence": "Терностручовий пліт",
  "block.minecraft.acacia_fence_gate": "Терностручова фіртка",
  "block.minecraft.acacia_hanging_sign": "Терностручова вивіска",
  "block.minecraft.acacia_leaves": "Терностручове листє",
  "block.minecraft.acacia_log": "Терностручова ковбицє",
  "block.minecraft.acacia_planks": "Терностручові дошки",
  "block.minecraft.acacia_pressure_plate": "Терностручова наступна плита",
  "block.minecraft.acacia_sapling": "Терностручова щіпа",
  "block.minecraft.acacia_shelf": "Терностручова полицє",
  "block.minecraft.acacia_sign": "Терностручовий знак",
  "block.minecraft.acacia_slab": "Терностручова плита",
  "block.minecraft.acacia_stairs": "Терностручові сходи",
  "block.minecraft.acacia_trapdoor": "Терностручова ляда",
  "block.minecraft.acacia_wall_hanging_sign": "Терностручова стїнна вивіска",
  "block.minecraft.acacia_wall_sign": "Терностручовий стїний знак",
  "block.minecraft.acacia_wood": "Терностручове дерево",
  "block.minecraft.activator_rail": "Штрека-гактиватор",
  "block.minecraft.air": "Повітрє",
  "block.minecraft.allium": "Трамбух",
  "block.minecraft.amethyst_block": "Вометистовий бльок",
  "block.minecraft.amethyst_cluster": "Вометистовий клястер",
  "block.minecraft.ancient_debris": "Старолїтні кававки",
  "block.minecraft.andesite": "Гандезит",
  "block.minecraft.andesite_slab": "Гандезитова плита",
  "block.minecraft.andesite_stairs": "Гандезитові сходи",
  "block.minecraft.andesite_wall": "Гандезитовий мур",
  "block.minecraft.anvil": "Ковадло",
  "block.minecraft.attached_melon_stem": "Кавунове бадилє",
  "block.minecraft.attached_pumpkin_stem": "Гарбузове бадилє",
  "block.minecraft.azalea": "Газалїя",
  "block.minecraft.azalea_leaves": "Газалїйове листє",
  "block.minecraft.azure_bluet": "Польова ромашка",
  "block.minecraft.bamboo": "Бамбус",
  "block.minecraft.bamboo_block": "Бамбусовий бльок",
  "block.minecraft.bamboo_button": "Бамбусова кнопка",
  "block.minecraft.bamboo_door": "Бамбусові двери",
  "block.minecraft.bamboo_fence": "Бамбусовий пліт",
  "block.minecraft.bamboo_fence_gate": "Бамбусова фіртка",
  "block.minecraft.bamboo_hanging_sign": "Бамбусова вивіска",
  "block.minecraft.bamboo_mosaic": "Бамбусова мозаїка",
  "block.minecraft.bamboo_mosaic_slab": "Бамбусова плита з мозаїков",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбусові сходи з мозаїков",
  "block.minecraft.bamboo_planks": "Бамбусові дошки",
  "block.minecraft.bamboo_pressure_plate": "Бамбусова наступна плита",
  "block.minecraft.bamboo_sapling": "Бамбусова щіпа",
  "block.minecraft.bamboo_shelf": "Бамбусова полицє",
  "block.minecraft.bamboo_sign": "Бамбусовий знак",
  "block.minecraft.bamboo_slab": "Бамбусова плита",
  "block.minecraft.bamboo_stairs": "Бамбусові сходи",
  "block.minecraft.bamboo_trapdoor": "Бамбусова ляда",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбусова стїна вивіска",
  "block.minecraft.bamboo_wall_sign": "Бамбусовий стїний знак",
  "block.minecraft.banner.base.black": "Цївком чорне тло",
  "block.minecraft.banner.base.blue": "Цївком сине тло",
  "block.minecraft.banner.base.brown": "Цївком брунатне тло",
  "block.minecraft.banner.base.cyan": "Цївком морске тло",
  "block.minecraft.banner.base.gray": "Цївком сїре тло",
  "block.minecraft.banner.base.green": "Цївком дзелене тло",
  "block.minecraft.banner.base.light_blue": "Цївком голубе тло",
  "block.minecraft.banner.base.light_gray": "Цївком крицеве тло",
  "block.minecraft.banner.base.lime": "Цївком салатове тло",
  "block.minecraft.banner.base.magenta": "Цївком фукзиєве тло",
  "block.minecraft.banner.base.orange": "Цївком цеглове тло",
  "block.minecraft.banner.base.pink": "Цївком ружове тло",
  "block.minecraft.banner.base.purple": "Цївком фійолєтове тло",
  "block.minecraft.banner.base.red": "Цївком черлене тло",
  "block.minecraft.banner.base.white": "Цївком біле тло",
  "block.minecraft.banner.base.yellow": "Цївком жовте тло",
  "block.minecraft.banner.border.black": "Чорна границє",
  "block.minecraft.banner.border.blue": "Сина границє",
  "block.minecraft.banner.border.brown": "Брунатна границє",
  "block.minecraft.banner.border.cyan": "Морска границє",
  "block.minecraft.banner.border.gray": "Сїра границє",
  "block.minecraft.banner.border.green": "Дзелена границє",
  "block.minecraft.banner.border.light_blue": "Голуба границє",
  "block.minecraft.banner.border.light_gray": "Крицева границє",
  "block.minecraft.banner.border.lime": "Салатова границє",
  "block.minecraft.banner.border.magenta": "Фукзиєва границє",
  "block.minecraft.banner.border.orange": "Цеглова границє",
  "block.minecraft.banner.border.pink": "Ружова границє",
  "block.minecraft.banner.border.purple": "Фійолєтова границє",
  "block.minecraft.banner.border.red": "Черлена границє",
  "block.minecraft.banner.border.white": "Біла границє",
  "block.minecraft.banner.border.yellow": "Жовта границє",
  "block.minecraft.banner.bricks.black": "Чорне цеглєне тло",
  "block.minecraft.banner.bricks.blue": "Сине цеглєне тло",
  "block.minecraft.banner.bricks.brown": "Брунатне цеглєне тло",
  "block.minecraft.banner.bricks.cyan": "Морске цеглєне тло",
  "block.minecraft.banner.bricks.gray": "Сїре цеглєне тло",
  "block.minecraft.banner.bricks.green": "Дзелене цеглєне тло",
  "block.minecraft.banner.bricks.light_blue": "Голубе цеглєне тло",
  "block.minecraft.banner.bricks.light_gray": "Крицеве цеглєне тло",
  "block.minecraft.banner.bricks.lime": "Салатове цеглєне тло",
  "block.minecraft.banner.bricks.magenta": "Фукзиєве цеглєне тло",
  "block.minecraft.banner.bricks.orange": "Цеглове цеглєне тло",
  "block.minecraft.banner.bricks.pink": "Ружове цеглєне тло",
  "block.minecraft.banner.bricks.purple": "Фійолєтове цеглєне тло",
  "block.minecraft.banner.bricks.red": "Черлене цеглєне тло",
  "block.minecraft.banner.bricks.white": "Біле цеглєне тло",
  "block.minecraft.banner.bricks.yellow": "Жовте цеглєне тло",
  "block.minecraft.banner.circle.black": "Чорний круг",
  "block.minecraft.banner.circle.blue": "Синий круг",
  "block.minecraft.banner.circle.brown": "Брунатний круг",
  "block.minecraft.banner.circle.cyan": "Морский круг",
  "block.minecraft.banner.circle.gray": "Сїрий круг",
  "block.minecraft.banner.circle.green": "Дзелений круг",
  "block.minecraft.banner.circle.light_blue": "Голубий круг",
  "block.minecraft.banner.circle.light_gray": "Крицевий круг",
  "block.minecraft.banner.circle.lime": "Салатовий круг",
  "block.minecraft.banner.circle.magenta": "Фукзиєвий круг",
  "block.minecraft.banner.circle.orange": "Цегловий круг",
  "block.minecraft.banner.circle.pink": "Ружовий круг",
  "block.minecraft.banner.circle.purple": "Фійолєтовий круг",
  "block.minecraft.banner.circle.red": "Черлений круг",
  "block.minecraft.banner.circle.white": "Білий круг",
  "block.minecraft.banner.circle.yellow": "Жовтий круг",
  "block.minecraft.banner.creeper.black": "Чорна твар крипера",
  "block.minecraft.banner.creeper.blue": "Сина твар крипера",
  "block.minecraft.banner.creeper.brown": "Брунатна твар крипера",
  "block.minecraft.banner.creeper.cyan": "Морска твар крипера",
  "block.minecraft.banner.creeper.gray": "Сїра твар крипера",
  "block.minecraft.banner.creeper.green": "Дзелена твар крипера",
  "block.minecraft.banner.creeper.light_blue": "Голуба твар крипера",
  "block.minecraft.banner.creeper.light_gray": "Крицева твар крипера",
  "block.minecraft.banner.creeper.lime": "Салатова твар крипера",
  "block.minecraft.banner.creeper.magenta": "Фукзиєва твар крипера",
  "block.minecraft.banner.creeper.orange": "Цеглова твар крипера",
  "block.minecraft.banner.creeper.pink": "Ружова твар крипера",
  "block.minecraft.banner.creeper.purple": "Фійолєтова твар крипера",
  "block.minecraft.banner.creeper.red": "Черлена твар крипера",
  "block.minecraft.banner.creeper.white": "Біла твар крипера",
  "block.minecraft.banner.creeper.yellow": "Жовта твар крипера",
  "block.minecraft.banner.cross.black": "Чорний Яндреїв хрест",
  "block.minecraft.banner.cross.blue": "Синий Яндреїв хрест",
  "block.minecraft.banner.cross.brown": "Брунатний Яндреїв хрест",
  "block.minecraft.banner.cross.cyan": "Морский Яндреїв хрест",
  "block.minecraft.banner.cross.gray": "Сїрий Яндреїв хрест",
  "block.minecraft.banner.cross.green": "Дзелений Яндреїв хрест",
  "block.minecraft.banner.cross.light_blue": "Голубий Яндреїв хрест",
  "block.minecraft.banner.cross.light_gray": "Крицевий Яндреїв хрест",
  "block.minecraft.banner.cross.lime": "Салатовий Яндреїв хрест",
  "block.minecraft.banner.cross.magenta": "Фукзиєвий Яндреїв хрест",
  "block.minecraft.banner.cross.orange": "Цегловий Яндреїв хрест",
  "block.minecraft.banner.cross.pink": "Ружовий Яндреїв хрест",
  "block.minecraft.banner.cross.purple": "Фійолєтовий Яндреїв хрест",
  "block.minecraft.banner.cross.red": "Черлений Яндреїв хрест",
  "block.minecraft.banner.cross.white": "Білий Яндреїв хрест",
  "block.minecraft.banner.cross.yellow": "Жовтий Яндреїв хрест",
  "block.minecraft.banner.curly_border.black": "Чорна зубчєта границє",
  "block.minecraft.banner.curly_border.blue": "Сина зубчєта границє",
  "block.minecraft.banner.curly_border.brown": "Брунатна зубчєта границє",
  "block.minecraft.banner.curly_border.cyan": "Морска зубчєта границє",
  "block.minecraft.banner.curly_border.gray": "Сїра зубчєта границє",
  "block.minecraft.banner.curly_border.green": "Дзелена зубчєта границє",
  "block.minecraft.banner.curly_border.light_blue": "Голуба зубчєта границє",
  "block.minecraft.banner.curly_border.light_gray": "Крицева зубчєта границє",
  "block.minecraft.banner.curly_border.lime": "Салатова зубчєта границє",
  "block.minecraft.banner.curly_border.magenta": "Фукзиєва зубчєта границє",
  "block.minecraft.banner.curly_border.orange": "Цеглова зубчєта границє",
  "block.minecraft.banner.curly_border.pink": "Ружова зубчєта границє",
  "block.minecraft.banner.curly_border.purple": "Фійолєтова зубчєта границє",
  "block.minecraft.banner.curly_border.red": "Черлена зубчєта границє",
  "block.minecraft.banner.curly_border.white": "Біла зубчєта границє",
  "block.minecraft.banner.curly_border.yellow": "Жовта зубчєта границє",
  "block.minecraft.banner.diagonal_left.black": "Чорний трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.blue": "Синий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.brown": "Брунатний трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.cyan": "Морский трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.gray": "Сїрий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.green": "Дзелений трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.light_blue": "Голубий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.light_gray": "Крицевий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.lime": "Салатовий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.magenta": "Фукзиєвий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.orange": "Цегловий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.pink": "Ружовий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.purple": "Фійолєтовий трикутник горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.red": "Черлений трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.white": "Білий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_left.yellow": "Жовтий трикутник в горішнім лївім кутї",
  "block.minecraft.banner.diagonal_right.black": "Чорний трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.blue": "Синий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.brown": "Брунатний трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.cyan": "Морский трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.gray": "Сїрий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.green": "Дзелений трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.light_blue": "Голубий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.light_gray": "Світло-сїрий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.lime": "Салатовий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.magenta": "Фукзиєвий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.orange": "Цегловий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.pink": "Ружовий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.purple": "Фійолєтовий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.red": "Черлений трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.white": "Білий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_right.yellow": "Жовтий трикутник в правім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.black": "Чорний трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.blue": "Синий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.brown": "Брунатний трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.cyan": "Морский трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.gray": "Сїрий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.green": "Дзелений трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Голубий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Крицевий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.lime": "Салатовий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.magenta": "Фукзиєвий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.orange": "Цегловий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.pink": "Ружовий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.purple": "Фійолєтовий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.red": "Черлений трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.white": "Білий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жовтий трикутник в долїшнім лївім кутї",
  "block.minecraft.banner.diagonal_up_right.black": "Чорний трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.blue": "Синий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.brown": "Брунатний трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.cyan": "Морский трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.gray": "Сїрий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.green": "Дзелений трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Голубий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Крицевий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.lime": "Салатовий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.magenta": "Фукзиєвий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.orange": "Цегловий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.pink": "Ружовий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.purple": "Фійолєтовий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.red": "Черлений трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.white": "Білий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.diagonal_up_right.yellow": "\"Жовтий трикутник в долїшнім правім кутї",
  "block.minecraft.banner.flow.black": "Чорний потік",
  "block.minecraft.banner.flow.blue": "Синий потік",
  "block.minecraft.banner.flow.brown": "Брунатний потік",
  "block.minecraft.banner.flow.cyan": "Морский потік",
  "block.minecraft.banner.flow.gray": "Сїрий потік",
  "block.minecraft.banner.flow.green": "Дзелений потік",
  "block.minecraft.banner.flow.light_blue": "Голубий потік",
  "block.minecraft.banner.flow.light_gray": "Крицевий потік",
  "block.minecraft.banner.flow.lime": "Салатовий потік",
  "block.minecraft.banner.flow.magenta": "Фукзиєвий потік",
  "block.minecraft.banner.flow.orange": "Цегловий потік",
  "block.minecraft.banner.flow.pink": "Ружовий потік",
  "block.minecraft.banner.flow.purple": "Фійолєтовий потік",
  "block.minecraft.banner.flow.red": "Черлений потік",
  "block.minecraft.banner.flow.white": "Білий потік",
  "block.minecraft.banner.flow.yellow": "Жовтий потік",
  "block.minecraft.banner.flower.black": "Чорний цьвіт",
  "block.minecraft.banner.flower.blue": "Синий цьвіт",
  "block.minecraft.banner.flower.brown": "Брунатний цьвіт",
  "block.minecraft.banner.flower.cyan": "Морский цьвіт",
  "block.minecraft.banner.flower.gray": "Сїрий цьвіт",
  "block.minecraft.banner.flower.green": "Дзелений цьвіт",
  "block.minecraft.banner.flower.light_blue": "Голубий цьвіт",
  "block.minecraft.banner.flower.light_gray": "Крицевий цьвіт",
  "block.minecraft.banner.flower.lime": "Салатовий цьвіт",
  "block.minecraft.banner.flower.magenta": "Фукзиєвий цьвіт",
  "block.minecraft.banner.flower.orange": "Цегловий цьвіт",
  "block.minecraft.banner.flower.pink": "Ружовий цьвіт",
  "block.minecraft.banner.flower.purple": "Фійолєтовий цьвіт",
  "block.minecraft.banner.flower.red": "Черлений цьвіт",
  "block.minecraft.banner.flower.white": "Білий цьвіт",
  "block.minecraft.banner.flower.yellow": "Жовтий цьвіт",
  "block.minecraft.banner.globe.black": "Чорний ґльобус",
  "block.minecraft.banner.globe.blue": "Синий ґльобус",
  "block.minecraft.banner.globe.brown": "Брунатний ґльобус",
  "block.minecraft.banner.globe.cyan": "Морский ґльобус",
  "block.minecraft.banner.globe.gray": "Сїрий ґльобус",
  "block.minecraft.banner.globe.green": "Дзелений ґльобус",
  "block.minecraft.banner.globe.light_blue": "Голубий ґльобус",
  "block.minecraft.banner.globe.light_gray": "Крицевий ґльобус",
  "block.minecraft.banner.globe.lime": "Салатовий ґльобус",
  "block.minecraft.banner.globe.magenta": "Фукзиєвий ґльобус",
  "block.minecraft.banner.globe.orange": "Цегловий ґльобус",
  "block.minecraft.banner.globe.pink": "Ружовий ґльобус",
  "block.minecraft.banner.globe.purple": "Фійолєтовий ґльобус",
  "block.minecraft.banner.globe.red": "Черлений ґльобус",
  "block.minecraft.banner.globe.white": "Білий ґльобус",
  "block.minecraft.banner.globe.yellow": "Жовтий ґльобус",
  "block.minecraft.banner.gradient.black": "Чорний ґрадиєнт горі",
  "block.minecraft.banner.gradient.blue": "Синий ґрадиєнт горі",
  "block.minecraft.banner.gradient.brown": "Брунатний ґрадиєнт горі",
  "block.minecraft.banner.gradient.cyan": "Морский ґрадиєнт горі",
  "block.minecraft.banner.gradient.gray": "Сїрий ґрадиєнт горі",
  "block.minecraft.banner.gradient.green": "Дзелений ґрадиєнт горі",
  "block.minecraft.banner.gradient.light_blue": "Голубий ґрадиєнт горі",
  "block.minecraft.banner.gradient.light_gray": "Крицевий ґрадиєнт горі",
  "block.minecraft.banner.gradient.lime": "Салатовий ґрадиєнт горі",
  "block.minecraft.banner.gradient.magenta": "Фукзиєвий ґрадиєнт горі",
  "block.minecraft.banner.gradient.orange": "Цегловий ґрадиєнт горі",
  "block.minecraft.banner.gradient.pink": "Ружовий ґрадиєнт горі",
  "block.minecraft.banner.gradient.purple": "Фійолєтовий ґрадиєнт горі",
  "block.minecraft.banner.gradient.red": "Черлений ґрадиєнт горі",
  "block.minecraft.banner.gradient.white": "Білий ґрадиєнт горі",
  "block.minecraft.banner.gradient.yellow": "Жовтий ґрадиєнт горі",
  "block.minecraft.banner.gradient_up.black": "Чорний ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.blue": "Синий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.brown": "Брунатний ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.cyan": "Морский ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.gray": "Сїрий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.green": "Дзелений ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.light_blue": "Голубий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.light_gray": "Крицевий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.lime": "Салатовий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.magenta": "Фукзиєвий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.orange": "Цегловий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.pink": "Ружовий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.purple": "Фійолєтовий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.red": "Черлений ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.white": "Білий ґрадиєнт долів",
  "block.minecraft.banner.gradient_up.yellow": "Жовтий ґрадиєнт долів",
  "block.minecraft.banner.guster.black": "Чорний вітерец",
  "block.minecraft.banner.guster.blue": "Синий вітерец",
  "block.minecraft.banner.guster.brown": "Брунатний вітерец",
  "block.minecraft.banner.guster.cyan": "Морский вітерец",
  "block.minecraft.banner.guster.gray": "Сїрий вітерец",
  "block.minecraft.banner.guster.green": "Дзелений вітерец",
  "block.minecraft.banner.guster.light_blue": "Голубий вітерец",
  "block.minecraft.banner.guster.light_gray": "Крицевий вітерец",
  "block.minecraft.banner.guster.lime": "Салатовий вітерец",
  "block.minecraft.banner.guster.magenta": "Фукзиєвий вітерец",
  "block.minecraft.banner.guster.orange": "Цегловий вітерец",
  "block.minecraft.banner.guster.pink": "Ружовий вітерец",
  "block.minecraft.banner.guster.purple": "Фійолєтовий вітерец",
  "block.minecraft.banner.guster.red": "Черлений вітерец",
  "block.minecraft.banner.guster.white": "Білий вітерец",
  "block.minecraft.banner.guster.yellow": "Жовтий вітерец",
  "block.minecraft.banner.half_horizontal.black": "Чорна горішна половина",
  "block.minecraft.banner.half_horizontal.blue": "Сина горішна половина",
  "block.minecraft.banner.half_horizontal.brown": "Брунатна горішна половина",
  "block.minecraft.banner.half_horizontal.cyan": "Морска горішна половина",
  "block.minecraft.banner.half_horizontal.gray": "Сїра горішна половина",
  "block.minecraft.banner.half_horizontal.green": "Дзелена горішна половина",
  "block.minecraft.banner.half_horizontal.light_blue": "Голуба горішна половина",
  "block.minecraft.banner.half_horizontal.light_gray": "Крицева горішна половина",
  "block.minecraft.banner.half_horizontal.lime": "Салатова горішна половина",
  "block.minecraft.banner.half_horizontal.magenta": "Фукзиєва горішна половина",
  "block.minecraft.banner.half_horizontal.orange": "Цеглова горішна половина",
  "block.minecraft.banner.half_horizontal.pink": "Ружова горішна половина",
  "block.minecraft.banner.half_horizontal.purple": "Фійолєтова горішна половина",
  "block.minecraft.banner.half_horizontal.red": "Черлена горішна половина",
  "block.minecraft.banner.half_horizontal.white": "Біла горішна половина",
  "block.minecraft.banner.half_horizontal.yellow": "Жовта горішна половина",
  "block.minecraft.banner.half_horizontal_bottom.black": "Чорна долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Сина долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Брунатна долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Морска долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сїра долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.green": "Дзелена долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Голуба долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Крицева долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Салатова долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Фукзиєва долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Цеглова долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ружова долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Фійолєтова долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.red": "Черлена долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.white": "Біла долїшна половина",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жовта долїшна половина",
  "block.minecraft.banner.half_vertical.black": "Чорна лїва половина",
  "block.minecraft.banner.half_vertical.blue": "Сина лїва половина",
  "block.minecraft.banner.half_vertical.brown": "Брунатна лїва половина",
  "block.minecraft.banner.half_vertical.cyan": "Морска лїва половина",
  "block.minecraft.banner.half_vertical.gray": "Сїра лїва половина",
  "block.minecraft.banner.half_vertical.green": "Дзелена лїва половина",
  "block.minecraft.banner.half_vertical.light_blue": "Голуба лїва половина",
  "block.minecraft.banner.half_vertical.light_gray": "Крицева лїва половина",
  "block.minecraft.banner.half_vertical.lime": "Салатова лїва половина",
  "block.minecraft.banner.half_vertical.magenta": "Фукзиєва лїва половина",
  "block.minecraft.banner.half_vertical.orange": "Цеглова лїва половина",
  "block.minecraft.banner.half_vertical.pink": "Ружова лїва половина",
  "block.minecraft.banner.half_vertical.purple": "Фійолєтова лїва половина",
  "block.minecraft.banner.half_vertical.red": "Черлена лїва половина",
  "block.minecraft.banner.half_vertical.white": "Біла лїва половина",
  "block.minecraft.banner.half_vertical.yellow": "Жовта лїва половина",
  "block.minecraft.banner.half_vertical_right.black": "Чорна права половина",
  "block.minecraft.banner.half_vertical_right.blue": "Сина права половина",
  "block.minecraft.banner.half_vertical_right.brown": "Брунатна права половина",
  "block.minecraft.banner.half_vertical_right.cyan": "Морска права половина",
  "block.minecraft.banner.half_vertical_right.gray": "Сїра права половина",
  "block.minecraft.banner.half_vertical_right.green": "Дзелена права половина",
  "block.minecraft.banner.half_vertical_right.light_blue": "Голуба права половина",
  "block.minecraft.banner.half_vertical_right.light_gray": "Крицева права половина",
  "block.minecraft.banner.half_vertical_right.lime": "Салатова права половина",
  "block.minecraft.banner.half_vertical_right.magenta": "Фукзиєва права половина",
  "block.minecraft.banner.half_vertical_right.orange": "Цеглова права половина",
  "block.minecraft.banner.half_vertical_right.pink": "Ружова права половина",
  "block.minecraft.banner.half_vertical_right.purple": "Фійолєтова права половина",
  "block.minecraft.banner.half_vertical_right.red": "Черлена права половина",
  "block.minecraft.banner.half_vertical_right.white": "Біла права половина",
  "block.minecraft.banner.half_vertical_right.yellow": "Жовта права половина",
  "block.minecraft.banner.mojang.black": "Чорне шось",
  "block.minecraft.banner.mojang.blue": "Сине шось",
  "block.minecraft.banner.mojang.brown": "Брунатне шось",
  "block.minecraft.banner.mojang.cyan": "Морске шось",
  "block.minecraft.banner.mojang.gray": "Сїре шось",
  "block.minecraft.banner.mojang.green": "Дзелене шось",
  "block.minecraft.banner.mojang.light_blue": "Голубе шось",
  "block.minecraft.banner.mojang.light_gray": "Крицеве шось",
  "block.minecraft.banner.mojang.lime": "Салатове шось",
  "block.minecraft.banner.mojang.magenta": "Фукзиєве шось",
  "block.minecraft.banner.mojang.orange": "Цеглове шось",
  "block.minecraft.banner.mojang.pink": "Ружове шось",
  "block.minecraft.banner.mojang.purple": "Фійолєтове шось",
  "block.minecraft.banner.mojang.red": "Черлене шось",
  "block.minecraft.banner.mojang.white": "Біле шось",
  "block.minecraft.banner.mojang.yellow": "Жовте шось",
  "block.minecraft.banner.piglin.black": "Чорна рийка",
  "block.minecraft.banner.piglin.blue": "Сина рийка",
  "block.minecraft.banner.piglin.brown": "Брунатна рийка",
  "block.minecraft.banner.piglin.cyan": "Морска рийка",
  "block.minecraft.banner.piglin.gray": "Сїра рийка",
  "block.minecraft.banner.piglin.green": "Дзелена рийка",
  "block.minecraft.banner.piglin.light_blue": "Голуба рийка",
  "block.minecraft.banner.piglin.light_gray": "Крицева рийка",
  "block.minecraft.banner.piglin.lime": "Салатова рийка",
  "block.minecraft.banner.piglin.magenta": "Фукзиєва рийка",
  "block.minecraft.banner.piglin.orange": "Цеглова рийка",
  "block.minecraft.banner.piglin.pink": "Ружова рийка",
  "block.minecraft.banner.piglin.purple": "Фійолєтова рийка",
  "block.minecraft.banner.piglin.red": "Черлена рийка",
  "block.minecraft.banner.piglin.white": "Біла рийка",
  "block.minecraft.banner.piglin.yellow": "Жовта рийка",
  "block.minecraft.banner.rhombus.black": "Чорний ромб",
  "block.minecraft.banner.rhombus.blue": "Синий ромб",
  "block.minecraft.banner.rhombus.brown": "Брунатний ромб",
  "block.minecraft.banner.rhombus.cyan": "Морский ромб",
  "block.minecraft.banner.rhombus.gray": "Сїрий ромб",
  "block.minecraft.banner.rhombus.green": "Дзелений ромб",
  "block.minecraft.banner.rhombus.light_blue": "Голубий ромб",
  "block.minecraft.banner.rhombus.light_gray": "Крицевий ромб",
  "block.minecraft.banner.rhombus.lime": "Салатовий ромб",
  "block.minecraft.banner.rhombus.magenta": "Фукзиєвий ромб",
  "block.minecraft.banner.rhombus.orange": "Цегловий ромб",
  "block.minecraft.banner.rhombus.pink": "Ружовий ромб",
  "block.minecraft.banner.rhombus.purple": "Фійолєтовий ромб",
  "block.minecraft.banner.rhombus.red": "Черлений ромб",
  "block.minecraft.banner.rhombus.white": "Білий ромб",
  "block.minecraft.banner.rhombus.yellow": "Жовтий ромб",
  "block.minecraft.banner.skull.black": "Чорний череп",
  "block.minecraft.banner.skull.blue": "Синий череп",
  "block.minecraft.banner.skull.brown": "Брунатний череп",
  "block.minecraft.banner.skull.cyan": "Морский череп",
  "block.minecraft.banner.skull.gray": "Сїрий череп",
  "block.minecraft.banner.skull.green": "Дзелений череп",
  "block.minecraft.banner.skull.light_blue": "Голубий череп",
  "block.minecraft.banner.skull.light_gray": "Крицевий череп",
  "block.minecraft.banner.skull.lime": "Салатовий череп",
  "block.minecraft.banner.skull.magenta": "Фукзиєвий череп",
  "block.minecraft.banner.skull.orange": "Цегловий череп",
  "block.minecraft.banner.skull.pink": "Ружовий череп",
  "block.minecraft.banner.skull.purple": "Фійолєтовий череп",
  "block.minecraft.banner.skull.red": "Черлений череп",
  "block.minecraft.banner.skull.white": "Білий череп",
  "block.minecraft.banner.skull.yellow": "Жовтий череп",
  "block.minecraft.banner.small_stripes.black": "Чорні смуги шторца",
  "block.minecraft.banner.small_stripes.blue": "Сині смуги шторца",
  "block.minecraft.banner.small_stripes.brown": "Брунатні смуги шторца",
  "block.minecraft.banner.small_stripes.cyan": "Морскі смуги шторца",
  "block.minecraft.banner.small_stripes.gray": "Сїрі смуги шторца",
  "block.minecraft.banner.small_stripes.green": "Дзелені смуги шторца",
  "block.minecraft.banner.small_stripes.light_blue": "Голубі смуги шторца",
  "block.minecraft.banner.small_stripes.light_gray": "Крицеві смуги шторца",
  "block.minecraft.banner.small_stripes.lime": "Салатові смуги шторца",
  "block.minecraft.banner.small_stripes.magenta": "Фукзиєві смуги шторца",
  "block.minecraft.banner.small_stripes.orange": "Цеглові смуги шторца",
  "block.minecraft.banner.small_stripes.pink": "Ружові смуги шторца",
  "block.minecraft.banner.small_stripes.purple": "Фійолєтові смуги шторца",
  "block.minecraft.banner.small_stripes.red": "Черлені смуги шторца",
  "block.minecraft.banner.small_stripes.white": "Білі смуги шторца",
  "block.minecraft.banner.small_stripes.yellow": "Жовті смуги шторца",
  "block.minecraft.banner.square_bottom_left.black": "Чорний долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.blue": "Синий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.brown": "Брунатний долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.cyan": "Морский долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.gray": "Сїрий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.green": "Дзелений долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.light_blue": "Голубий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.light_gray": "Крицевий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.lime": "Салатовий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.magenta": "Фукзиєвий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.orange": "Цегловий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.pink": "Ружовий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.purple": "Фійолєтовий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.red": "Черлений долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.white": "Білий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_left.yellow": "Жовтий долїшний лївий квадрат",
  "block.minecraft.banner.square_bottom_right.black": "Чорний долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.blue": "Синий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.brown": "Брунатний долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.cyan": "Морский долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.gray": "Сїрий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.green": "Дзелений долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.light_blue": "Голубий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.light_gray": "Крицевий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.lime": "Салатовий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.magenta": "Фукзиєвий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.orange": "Цегловий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.pink": "Ружовий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.purple": "Фійолєтовий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.red": "Черлений долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.white": "Білий долїшний правий квадрат",
  "block.minecraft.banner.square_bottom_right.yellow": "Жовтий долїшний правий квадрат",
  "block.minecraft.banner.square_top_left.black": "Чорний горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.blue": "Синий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.brown": "Брунатний горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.cyan": "Морский горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.gray": "Сїрий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.green": "Дзелений горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.light_blue": "Голубий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.light_gray": "Крицевий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.lime": "Салатовий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.magenta": "Фукзиєвий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.orange": "Цегловий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.pink": "Ружовий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.purple": "Фійолєтовий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.red": "Черлений горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.white": "Білий горішний лївий квадрат",
  "block.minecraft.banner.square_top_left.yellow": "Жовтий горішний лївий квадрат",
  "block.minecraft.banner.square_top_right.black": "Чорний горішний правий квадрат",
  "block.minecraft.banner.square_top_right.blue": "Синий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.brown": "Брунатний горішний правий квадрат",
  "block.minecraft.banner.square_top_right.cyan": "Морский горішний правий квадрат",
  "block.minecraft.banner.square_top_right.gray": "Сїрий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.green": "Дзелений горішний правий квадрат",
  "block.minecraft.banner.square_top_right.light_blue": "Голубий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.light_gray": "Крицевий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.lime": "Салатовий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.magenta": "Фукзиєвий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.orange": "Цегловий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.pink": "Ружовий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.purple": "Фійолєтовий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.red": "Черлений горішний правий квадрат",
  "block.minecraft.banner.square_top_right.white": "Білий горішний правий квадрат",
  "block.minecraft.banner.square_top_right.yellow": "Жовтий горішний правий квадрат",
  "block.minecraft.banner.straight_cross.black": "Чорний хрест",
  "block.minecraft.banner.straight_cross.blue": "Синий хрест",
  "block.minecraft.banner.straight_cross.brown": "Брунатний хрест",
  "block.minecraft.banner.straight_cross.cyan": "Морский хрест",
  "block.minecraft.banner.straight_cross.gray": "Сїрий хрест",
  "block.minecraft.banner.straight_cross.green": "Дзелений хрест",
  "block.minecraft.banner.straight_cross.light_blue": "Голубий хрест",
  "block.minecraft.banner.straight_cross.light_gray": "Крицевий хрест",
  "block.minecraft.banner.straight_cross.lime": "Салатовий хрест",
  "block.minecraft.banner.straight_cross.magenta": "Фукзиєвий хрест",
  "block.minecraft.banner.straight_cross.orange": "Цегловий хрест",
  "block.minecraft.banner.straight_cross.pink": "Ружовий хрест",
  "block.minecraft.banner.straight_cross.purple": "Фійолєтовий хрест",
  "block.minecraft.banner.straight_cross.red": "Черлений хрест",
  "block.minecraft.banner.straight_cross.white": "Білий хрест",
  "block.minecraft.banner.straight_cross.yellow": "Жовтий хрест",
  "block.minecraft.banner.stripe_bottom.black": "Чорна долина",
  "block.minecraft.banner.stripe_bottom.blue": "Сина долина",
  "block.minecraft.banner.stripe_bottom.brown": "Брунатна долина",
  "block.minecraft.banner.stripe_bottom.cyan": "Морска долина",
  "block.minecraft.banner.stripe_bottom.gray": "Сїра долина",
  "block.minecraft.banner.stripe_bottom.green": "Дзелена долина",
  "block.minecraft.banner.stripe_bottom.light_blue": "Голуба долина",
  "block.minecraft.banner.stripe_bottom.light_gray": "Крицева долина",
  "block.minecraft.banner.stripe_bottom.lime": "Салатова долина",
  "block.minecraft.banner.stripe_bottom.magenta": "Фукзиєва долина",
  "block.minecraft.banner.stripe_bottom.orange": "Цеглова долина",
  "block.minecraft.banner.stripe_bottom.pink": "Ружова долина",
  "block.minecraft.banner.stripe_bottom.purple": "Фійолєтова долина",
  "block.minecraft.banner.stripe_bottom.red": "Черлена долина",
  "block.minecraft.banner.stripe_bottom.white": "Біла долина",
  "block.minecraft.banner.stripe_bottom.yellow": "Жовта долина",
  "block.minecraft.banner.stripe_center.black": "Чорний стовп",
  "block.minecraft.banner.stripe_center.blue": "Синий стовп",
  "block.minecraft.banner.stripe_center.brown": "Брунатний стовп",
  "block.minecraft.banner.stripe_center.cyan": "Морский стовп",
  "block.minecraft.banner.stripe_center.gray": "Сїрий стовп",
  "block.minecraft.banner.stripe_center.green": "Дзелений стовп",
  "block.minecraft.banner.stripe_center.light_blue": "Голубий стовп",
  "block.minecraft.banner.stripe_center.light_gray": "Крицевий стовп",
  "block.minecraft.banner.stripe_center.lime": "Салатовий стовп",
  "block.minecraft.banner.stripe_center.magenta": "Фукзиєвий стовп",
  "block.minecraft.banner.stripe_center.orange": "Цегловий стовп",
  "block.minecraft.banner.stripe_center.pink": "Ружовий стовп",
  "block.minecraft.banner.stripe_center.purple": "Фійолєтовий стовп",
  "block.minecraft.banner.stripe_center.red": "Черлений стовп",
  "block.minecraft.banner.stripe_center.white": "Білий стовп",
  "block.minecraft.banner.stripe_center.yellow": "Жовтий стовп",
  "block.minecraft.banner.stripe_downleft.black": "Чорна дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.blue": "Сина дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.brown": "Брунатна дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.cyan": "Морска дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.gray": "Сїра дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.green": "Дзелена дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.light_blue": "Голуба дияґональ справа наліво",
  "block.minecraft.banner.stripe_downleft.light_gray": "Крицева дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.lime": "Салатова дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.magenta": "Фукзиєва дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.orange": "Цеглова дияґональ справа наліво",
  "block.minecraft.banner.stripe_downleft.pink": "Ружова дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.purple": "Фійолєтова дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.red": "Черлена дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.white": "Біла дияґональ справа налїво",
  "block.minecraft.banner.stripe_downleft.yellow": "Жовта дияґональ справа налїво",
  "block.minecraft.banner.stripe_downright.black": "Чорна дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.blue": "Сина дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.brown": "Брунатна дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.cyan": "Морска дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.gray": "Сїра дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.green": "Дзелена дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.light_blue": "Голуба дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.light_gray": "Крицева дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.lime": "Салатова дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.magenta": "Фукзиєва дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.orange": "Цеглова дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.pink": "Ружова дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.purple": "Фійолєтова дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.red": "Черлена дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.white": "Біла дияґональ злїва направо",
  "block.minecraft.banner.stripe_downright.yellow": "Жовта дияґональ злїва направо",
  "block.minecraft.banner.stripe_left.black": "Чорна смуга шторца злїва",
  "block.minecraft.banner.stripe_left.blue": "Сина смуга шторца злїва",
  "block.minecraft.banner.stripe_left.brown": "Брунатна смуга шторца злїва",
  "block.minecraft.banner.stripe_left.cyan": "Морска смуга шторца злїва",
  "block.minecraft.banner.stripe_left.gray": "Сїра смуга шторца злїва",
  "block.minecraft.banner.stripe_left.green": "Дзелена смуга шторца злїва",
  "block.minecraft.banner.stripe_left.light_blue": "Голуба смуга шторца злїва",
  "block.minecraft.banner.stripe_left.light_gray": "Крицева смуга шторца злїва",
  "block.minecraft.banner.stripe_left.lime": "Салатова смуга шторца злїва",
  "block.minecraft.banner.stripe_left.magenta": "Фукзиєва смуга шторца злїва",
  "block.minecraft.banner.stripe_left.orange": "Цеглова смуга шторца злїва",
  "block.minecraft.banner.stripe_left.pink": "Ружова смуга шторца злїва",
  "block.minecraft.banner.stripe_left.purple": "Фійолєтова смуга шторца злїва",
  "block.minecraft.banner.stripe_left.red": "Черлена смуга шторца злїва",
  "block.minecraft.banner.stripe_left.white": "Біла смуга шторца злїва",
  "block.minecraft.banner.stripe_left.yellow": "Жовта смуга шторца злїва",
  "block.minecraft.banner.stripe_middle.black": "Чорна середина",
  "block.minecraft.banner.stripe_middle.blue": "Сина середина",
  "block.minecraft.banner.stripe_middle.brown": "Брунатна середина",
  "block.minecraft.banner.stripe_middle.cyan": "Морска середина",
  "block.minecraft.banner.stripe_middle.gray": "Сїра середина",
  "block.minecraft.banner.stripe_middle.green": "Дзелена середина",
  "block.minecraft.banner.stripe_middle.light_blue": "Голуба середина",
  "block.minecraft.banner.stripe_middle.light_gray": "Крицева середина",
  "block.minecraft.banner.stripe_middle.lime": "Салатова середина",
  "block.minecraft.banner.stripe_middle.magenta": "Фукзиєва середина",
  "block.minecraft.banner.stripe_middle.orange": "Цеглова середина",
  "block.minecraft.banner.stripe_middle.pink": "Ружова середина",
  "block.minecraft.banner.stripe_middle.purple": "Фійолєтова середина",
  "block.minecraft.banner.stripe_middle.red": "Черлена середина",
  "block.minecraft.banner.stripe_middle.white": "Біла середина",
  "block.minecraft.banner.stripe_middle.yellow": "Жовта середина",
  "block.minecraft.banner.stripe_right.black": "Чорна смуга шторца справа",
  "block.minecraft.banner.stripe_right.blue": "Сина смуга шторца справа",
  "block.minecraft.banner.stripe_right.brown": "Брунатна смуга шторца справа",
  "block.minecraft.banner.stripe_right.cyan": "Морска смуга шторца справа",
  "block.minecraft.banner.stripe_right.gray": "Сїра смуга шторца справа",
  "block.minecraft.banner.stripe_right.green": "Дзелена смуга шторца справа",
  "block.minecraft.banner.stripe_right.light_blue": "Голуба смуга шторца справа",
  "block.minecraft.banner.stripe_right.light_gray": "Крицева смуга шторца справа",
  "block.minecraft.banner.stripe_right.lime": "Салатова смуга шторца справа",
  "block.minecraft.banner.stripe_right.magenta": "Фукзиєва смуга шторца справа",
  "block.minecraft.banner.stripe_right.orange": "Цеглова смуга шторца справа",
  "block.minecraft.banner.stripe_right.pink": "Ружова смуга шторца справа",
  "block.minecraft.banner.stripe_right.purple": "Фійолєтова смуга шторца справа",
  "block.minecraft.banner.stripe_right.red": "Черлена смуга шторца справа",
  "block.minecraft.banner.stripe_right.white": "Біла смуга шторца справа",
  "block.minecraft.banner.stripe_right.yellow": "Жовта смуга шторца справа",
  "block.minecraft.banner.stripe_top.black": "Чорна гора",
  "block.minecraft.banner.stripe_top.blue": "Сина гора",
  "block.minecraft.banner.stripe_top.brown": "Брунатна гора",
  "block.minecraft.banner.stripe_top.cyan": "Морска гора",
  "block.minecraft.banner.stripe_top.gray": "Сїра гора",
  "block.minecraft.banner.stripe_top.green": "Дзелена гора",
  "block.minecraft.banner.stripe_top.light_blue": "Голуба гора",
  "block.minecraft.banner.stripe_top.light_gray": "Крицева гора",
  "block.minecraft.banner.stripe_top.lime": "Салатова гора",
  "block.minecraft.banner.stripe_top.magenta": "Фукзиєва гора",
  "block.minecraft.banner.stripe_top.orange": "Цеглова гора",
  "block.minecraft.banner.stripe_top.pink": "Ружова гора",
  "block.minecraft.banner.stripe_top.purple": "Фійолєтова гора",
  "block.minecraft.banner.stripe_top.red": "Черлена гора",
  "block.minecraft.banner.stripe_top.white": "Біла гора",
  "block.minecraft.banner.stripe_top.yellow": "Жовта гора",
  "block.minecraft.banner.triangle_bottom.black": "Чорний долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.blue": "Синий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.brown": "Брунатний долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.cyan": "Морский долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.gray": "Сїрий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.green": "Дзелений долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.light_blue": "Голубий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.light_gray": "Крицевий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.lime": "Салатовий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.magenta": "Фукзиєвий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.orange": "Цегловий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.pink": "Ружовий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.purple": "Фійолєтовий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.red": "Черлений долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.white": "Білий долїшний трикутник",
  "block.minecraft.banner.triangle_bottom.yellow": "Жовтий долїшний трикутник",
  "block.minecraft.banner.triangle_top.black": "Чорний горішний трикутник",
  "block.minecraft.banner.triangle_top.blue": "Синий горішний трикутник",
  "block.minecraft.banner.triangle_top.brown": "Брунатний горішний трикутник",
  "block.minecraft.banner.triangle_top.cyan": "Морский горішний трикутник",
  "block.minecraft.banner.triangle_top.gray": "Сїрий горішний трикутник",
  "block.minecraft.banner.triangle_top.green": "Дзелений горішний трикутник",
  "block.minecraft.banner.triangle_top.light_blue": "Голубий горішний трикутник",
  "block.minecraft.banner.triangle_top.light_gray": "Крицевий горішний трикутник",
  "block.minecraft.banner.triangle_top.lime": "Салатовий горішний трикутник",
  "block.minecraft.banner.triangle_top.magenta": "Фукзиєвий горішний трикутник",
  "block.minecraft.banner.triangle_top.orange": "Цегловий горішний трикутник",
  "block.minecraft.banner.triangle_top.pink": "Ружовий горішний трикутник",
  "block.minecraft.banner.triangle_top.purple": "Фійолєтовий горішний трикутник",
  "block.minecraft.banner.triangle_top.red": "Черлений горішний трикутник",
  "block.minecraft.banner.triangle_top.white": "Білий горішний трикутник",
  "block.minecraft.banner.triangle_top.yellow": "Жовтий горішний трикутник",
  "block.minecraft.banner.triangles_bottom.black": "Чорні зуби долів",
  "block.minecraft.banner.triangles_bottom.blue": "Сині зуби вдолів",
  "block.minecraft.banner.triangles_bottom.brown": "Брунатні зуби долів",
  "block.minecraft.banner.triangles_bottom.cyan": "Морскі зуби долів",
  "block.minecraft.banner.triangles_bottom.gray": "Сїрі зуби долів",
  "block.minecraft.banner.triangles_bottom.green": "Дзелені зуби долів",
  "block.minecraft.banner.triangles_bottom.light_blue": "Голубі зуби долів",
  "block.minecraft.banner.triangles_bottom.light_gray": "Крицеві зуби долів",
  "block.minecraft.banner.triangles_bottom.lime": "Салатові зуби долів",
  "block.minecraft.banner.triangles_bottom.magenta": "Фукзиєві зуби долів",
  "block.minecraft.banner.triangles_bottom.orange": "Цеглові зуби долів",
  "block.minecraft.banner.triangles_bottom.pink": "Ружові зуби долів",
  "block.minecraft.banner.triangles_bottom.purple": "Фійолєтові зуби долів",
  "block.minecraft.banner.triangles_bottom.red": "Черлені зуби долів",
  "block.minecraft.banner.triangles_bottom.white": "Білі зуби долів",
  "block.minecraft.banner.triangles_bottom.yellow": "Жовті зуби долів",
  "block.minecraft.banner.triangles_top.black": "Чорні зуби горі",
  "block.minecraft.banner.triangles_top.blue": "Сині зуби горі",
  "block.minecraft.banner.triangles_top.brown": "Брунатні зуби горі",
  "block.minecraft.banner.triangles_top.cyan": "Морскі зуби горі",
  "block.minecraft.banner.triangles_top.gray": "Сїрі зуби горі",
  "block.minecraft.banner.triangles_top.green": "Дзелені зуби горі",
  "block.minecraft.banner.triangles_top.light_blue": "Голубі зуби горі",
  "block.minecraft.banner.triangles_top.light_gray": "Крицеві зуби горі",
  "block.minecraft.banner.triangles_top.lime": "Салатові зуби горі",
  "block.minecraft.banner.triangles_top.magenta": "Фукзиєві зуби горі",
  "block.minecraft.banner.triangles_top.orange": "Цеглові зуби горі",
  "block.minecraft.banner.triangles_top.pink": "Ружові зуби горі",
  "block.minecraft.banner.triangles_top.purple": "Фійолєтові зуби горі",
  "block.minecraft.banner.triangles_top.red": "Черлені зуби горі",
  "block.minecraft.banner.triangles_top.white": "Білі зуби горі",
  "block.minecraft.banner.triangles_top.yellow": "Жовті зуби горі",
  "block.minecraft.barrel": "Бочка",
  "block.minecraft.barrier": "Запора",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Первина міч",
  "block.minecraft.beacon.secondary": "Вторина міч",
  "block.minecraft.bed.no_sleep": "Ви годні спати лиш вночи ци заки є злива",
  "block.minecraft.bed.not_safe": "Не годні-сте лєчи, тутка десь є почвари",
  "block.minecraft.bed.obstructed": "То ліжко є загороджене",
  "block.minecraft.bed.occupied": "То ліжко зайнєте",
  "block.minecraft.bed.too_far_away": "Не годні-сте зара лєчи, ліжко задалеко",
  "block.minecraft.bedrock": "Бедрок",
  "block.minecraft.bee_nest": "Пчолине гнїздо",
  "block.minecraft.beehive": "Вулий",
  "block.minecraft.beetroots": "Бурак",
  "block.minecraft.bell": "Дзвін",
  "block.minecraft.big_dripleaf": "Великий краполист",
  "block.minecraft.big_dripleaf_stem": "Бадилє великого краполиста",
  "block.minecraft.birch_button": "Березова кнопка",
  "block.minecraft.birch_door": "Березові двери",
  "block.minecraft.birch_fence": "Березовий пліт",
  "block.minecraft.birch_fence_gate": "Березова фіртка",
  "block.minecraft.birch_hanging_sign": "Березова вивіска",
  "block.minecraft.birch_leaves": "Березове листє",
  "block.minecraft.birch_log": "Березова ковбицє",
  "block.minecraft.birch_planks": "Березові дошки",
  "block.minecraft.birch_pressure_plate": "Березова наступна плита",
  "block.minecraft.birch_sapling": "Березова щіпа",
  "block.minecraft.birch_shelf": "Березова полицє",
  "block.minecraft.birch_sign": "Березовий знак",
  "block.minecraft.birch_slab": "Березова плита",
  "block.minecraft.birch_stairs": "Березові сходи",
  "block.minecraft.birch_trapdoor": "Березова ляда",
  "block.minecraft.birch_wall_hanging_sign": "Березова стїна вивіска",
  "block.minecraft.birch_wall_sign": "Березовий стїний знак",
  "block.minecraft.birch_wood": "Березове дерево",
  "block.minecraft.black_banner": "Чорна фана",
  "block.minecraft.black_bed": "Чорне ліжко",
  "block.minecraft.black_candle": "Чорна сьвічка",
  "block.minecraft.black_candle_cake": "Пляцок зо чорнов сьвічков",
  "block.minecraft.black_carpet": "Чорний хідник",
  "block.minecraft.black_concrete": "Чорний бетон",
  "block.minecraft.black_concrete_powder": "Чорний цїмент",
  "block.minecraft.black_glazed_terracotta": "Чорна поливєна печина",
  "block.minecraft.black_shulker_box": "Чорне шулькер-пудевко",
  "block.minecraft.black_stained_glass": "Чорне шкло",
  "block.minecraft.black_stained_glass_pane": "Чорна шиба",
  "block.minecraft.black_terracotta": "Чорна печина",
  "block.minecraft.black_wool": "Чорна вовна",
  "block.minecraft.blackstone": "Чорнокамінь",
  "block.minecraft.blackstone_slab": "Чорнокамнєна плита",
  "block.minecraft.blackstone_stairs": "Чорнокамнєні сходи",
  "block.minecraft.blackstone_wall": "Чорнокамнєний мур",
  "block.minecraft.blast_furnace": "Плавильний пєц",
  "block.minecraft.blue_banner": "Сина фана",
  "block.minecraft.blue_bed": "Сине ліжко",
  "block.minecraft.blue_candle": "Сина сьвічка",
  "block.minecraft.blue_candle_cake": "Пляцок зо синов сьвічков",
  "block.minecraft.blue_carpet": "Синий хідник",
  "block.minecraft.blue_concrete": "Синий бетон",
  "block.minecraft.blue_concrete_powder": "Синий цїмент",
  "block.minecraft.blue_glazed_terracotta": "Сина поливєна печина",
  "block.minecraft.blue_ice": "Синий лїд",
  "block.minecraft.blue_orchid": "Синий зазулинец",
  "block.minecraft.blue_shulker_box": "Сине шулькер-пудевко",
  "block.minecraft.blue_stained_glass": "Сине шкло",
  "block.minecraft.blue_stained_glass_pane": "Сина шиба",
  "block.minecraft.blue_terracotta": "Сина печина",
  "block.minecraft.blue_wool": "Сина вовна",
  "block.minecraft.bone_block": "Кістєний бльок",
  "block.minecraft.bookshelf": "Книжкова полицє",
  "block.minecraft.brain_coral": "Мозґовий кораль",
  "block.minecraft.brain_coral_block": "Бльок мозґового коралє",
  "block.minecraft.brain_coral_fan": "Мозґовий кораль-вахлєр",
  "block.minecraft.brain_coral_wall_fan": "Настїний мозґовий кораль-вахлєр",
  "block.minecraft.brewing_stand": "Варильна стійка",
  "block.minecraft.brick_slab": "Цеглєна плита",
  "block.minecraft.brick_stairs": "Цеглєні сходи",
  "block.minecraft.brick_wall": "Цеглєний мур",
  "block.minecraft.bricks": "Цегла",
  "block.minecraft.brown_banner": "Брунатна фана",
  "block.minecraft.brown_bed": "Брунатне ліжко",
  "block.minecraft.brown_candle": "Брунатна сьвічка",
  "block.minecraft.brown_candle_cake": "Пляцок зо брунатнов сьвічков",
  "block.minecraft.brown_carpet": "Брунатний хідник",
  "block.minecraft.brown_concrete": "Брунатний бетон",
  "block.minecraft.brown_concrete_powder": "Брунатний цїмент",
  "block.minecraft.brown_glazed_terracotta": "Брунатна поливєна печина",
  "block.minecraft.brown_mushroom": "Брунатна губа",
  "block.minecraft.brown_mushroom_block": "Бльок брунатних губів",
  "block.minecraft.brown_shulker_box": "Брунатне шулькер-пудевко",
  "block.minecraft.brown_stained_glass": "Брунатне шкло",
  "block.minecraft.brown_stained_glass_pane": "Брунатна шиба",
  "block.minecraft.brown_terracotta": "Брунатна печина",
  "block.minecraft.brown_wool": "Брунатна вовна",
  "block.minecraft.bubble_column": "Колона бульок",
  "block.minecraft.bubble_coral": "Бульковий кораль",
  "block.minecraft.bubble_coral_block": "Бльок булькового коралє",
  "block.minecraft.bubble_coral_fan": "Бульковий кораль-вахлєр",
  "block.minecraft.bubble_coral_wall_fan": "Настїний бульковий кораль-вахлєр",
  "block.minecraft.budding_amethyst": "Родючий вометист",
  "block.minecraft.bush": "Кущ",
  "block.minecraft.cactus": "Мнєжень",
  "block.minecraft.cactus_flower": "Цьвіт мнєжнє",
  "block.minecraft.cake": "Пляцок",
  "block.minecraft.calcite": "Вапнєнец",
  "block.minecraft.calibrated_sculk_sensor": "Калїбрований шкальковий сензор",
  "block.minecraft.campfire": "Ватра",
  "block.minecraft.candle": "Сьвічка",
  "block.minecraft.candle_cake": "Пляцок зо сьвічков",
  "block.minecraft.carrots": "Морква",
  "block.minecraft.cartography_table": "Стіл мапоґрафії",
  "block.minecraft.carved_pumpkin": "Врізаний гарбуз",
  "block.minecraft.cauldron": "Саганок",
  "block.minecraft.cave_air": "Печерне повітрє",
  "block.minecraft.cave_vines": "Печерні лози",
  "block.minecraft.cave_vines_plant": "Бадилє печерної лози",
  "block.minecraft.chain": "Дзелїзний ланц",
  "block.minecraft.chain_command_block": "Ланцовий наказовий бльок",
  "block.minecraft.cherry_button": "Вишнева кнопка",
  "block.minecraft.cherry_door": "Вишневі двери",
  "block.minecraft.cherry_fence": "Вишневий пліт",
  "block.minecraft.cherry_fence_gate": "Вишнева фіртка",
  "block.minecraft.cherry_hanging_sign": "Вишнева вивіска",
  "block.minecraft.cherry_leaves": "Вишневе листє",
  "block.minecraft.cherry_log": "Вишнева ковбицє",
  "block.minecraft.cherry_planks": "Вишневі дошки",
  "block.minecraft.cherry_pressure_plate": "Вишнева наступна плита",
  "block.minecraft.cherry_sapling": "Вишнева щіпа",
  "block.minecraft.cherry_shelf": "Вишнева полицє",
  "block.minecraft.cherry_sign": "Вишневий знак",
  "block.minecraft.cherry_slab": "Вишнева плита",
  "block.minecraft.cherry_stairs": "Вишневі сходи",
  "block.minecraft.cherry_trapdoor": "Вишнева ляда",
  "block.minecraft.cherry_wall_hanging_sign": "Вишнева стїна вивіска",
  "block.minecraft.cherry_wall_sign": "Вишневий стїний знак",
  "block.minecraft.cherry_wood": "Вишневе дерево",
  "block.minecraft.chest": "Куфер",
  "block.minecraft.chipped_anvil": "Надщерблене ковадло",
  "block.minecraft.chiseled_bookshelf": "Різьблена книжкова полицє",
  "block.minecraft.chiseled_copper": "Різьблена мідь",
  "block.minecraft.chiseled_deepslate": "Різьблений лупец",
  "block.minecraft.chiseled_nether_bricks": "Різьблена недерска цегла",
  "block.minecraft.chiseled_polished_blackstone": "Різьблений ґлянцований чорнокамінь",
  "block.minecraft.chiseled_quartz_block": "Різьблений бльок кварца",
  "block.minecraft.chiseled_red_sandstone": "Різьблений черлений пісковик",
  "block.minecraft.chiseled_resin_bricks": "Різьблена смолєна цегла",
  "block.minecraft.chiseled_sandstone": "Різьблений пісковик",
  "block.minecraft.chiseled_stone_bricks": "Різьблена камнєна цегла",
  "block.minecraft.chiseled_tuff": "Різьблений туф",
  "block.minecraft.chiseled_tuff_bricks": "Різьблена туфова цегла",
  "block.minecraft.chorus_flower": "Цьвіт хоруса",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Затворений вочкоцьвіт",
  "block.minecraft.coal_block": "Бльок вуглє",
  "block.minecraft.coal_ore": "Вугльова руда",
  "block.minecraft.coarse_dirt": "Загрубіла землє",
  "block.minecraft.cobbled_deepslate": "Лупцевий бут",
  "block.minecraft.cobbled_deepslate_slab": "Лупцева бутова плита",
  "block.minecraft.cobbled_deepslate_stairs": "Лупцеві бутові сходи",
  "block.minecraft.cobbled_deepslate_wall": "Лупцевий бутовий мур",
  "block.minecraft.cobblestone": "Бут",
  "block.minecraft.cobblestone_slab": "Бутова плита",
  "block.minecraft.cobblestone_stairs": "Бутові сходи",
  "block.minecraft.cobblestone_wall": "Бутовий мур",
  "block.minecraft.cobweb": "Павутицє",
  "block.minecraft.cocoa": "Какаво",
  "block.minecraft.command_block": "Наказовий бльок",
  "block.minecraft.comparator": "Редстовновий порімнювач",
  "block.minecraft.composter": "Компостер",
  "block.minecraft.conduit": "Провідник",
  "block.minecraft.copper_bars": "Мідні ґрати",
  "block.minecraft.copper_block": "Бльок міди",
  "block.minecraft.copper_bulb": "Мідна лямпа",
  "block.minecraft.copper_chain": "Мідний ланц",
  "block.minecraft.copper_chest": "Мідний куфер",
  "block.minecraft.copper_door": "Мідні двери",
  "block.minecraft.copper_golem_statue": "Статуя мідного ґолєма",
  "block.minecraft.copper_grate": "Мідна решітка",
  "block.minecraft.copper_lantern": "Мідна лямпа",
  "block.minecraft.copper_ore": "Мідна руда",
  "block.minecraft.copper_torch": "Мідний смолоскіп",
  "block.minecraft.copper_trapdoor": "Мідна ляда",
  "block.minecraft.copper_wall_torch": "Настїний мідний смолоскіп",
  "block.minecraft.cornflower": "Синоцьвіт",
  "block.minecraft.cracked_deepslate_bricks": "Тріснута лупцева цегла",
  "block.minecraft.cracked_deepslate_tiles": "Тріснута лупцева кафлє",
  "block.minecraft.cracked_nether_bricks": "Тріснута недереска цегла",
  "block.minecraft.cracked_polished_blackstone_bricks": "Тріснута ґлянцована чорнокамнєна цегла",
  "block.minecraft.cracked_stone_bricks": "Тріснута камнєна цегла",
  "block.minecraft.crafter": "Майструвач",
  "block.minecraft.crafting_table": "Варстат",
  "block.minecraft.creaking_heart": "Серце тріскачє",
  "block.minecraft.creeper_head": "Голова крипера",
  "block.minecraft.creeper_wall_head": "Стїна голова крипера",
  "block.minecraft.crimson_button": "Багрова кнопка",
  "block.minecraft.crimson_door": "Багрові двери",
  "block.minecraft.crimson_fence": "Багровий пліт",
  "block.minecraft.crimson_fence_gate": "Багрова фіртка",
  "block.minecraft.crimson_fungus": "Багрова губа",
  "block.minecraft.crimson_hanging_sign": "Багрова вивіска",
  "block.minecraft.crimson_hyphae": "Багровий гіф",
  "block.minecraft.crimson_nylium": "Багровий нїлїй",
  "block.minecraft.crimson_planks": "Багрові дошки",
  "block.minecraft.crimson_pressure_plate": "Багрова наступна плита",
  "block.minecraft.crimson_roots": "Багрове корінє",
  "block.minecraft.crimson_shelf": "Багрова полицє",
  "block.minecraft.crimson_sign": "Багровий знак",
  "block.minecraft.crimson_slab": "Багрова плита",
  "block.minecraft.crimson_stairs": "Багрові сходи",
  "block.minecraft.crimson_stem": "Багрове бадилє",
  "block.minecraft.crimson_trapdoor": "Багрова ляда",
  "block.minecraft.crimson_wall_hanging_sign": "Багрова стїна вивіска",
  "block.minecraft.crimson_wall_sign": "Багровий стїний знак",
  "block.minecraft.crying_obsidian": "Ревучий вобсидиян",
  "block.minecraft.cut_copper": "Виточена мідь",
  "block.minecraft.cut_copper_slab": "Виточена мідна плита",
  "block.minecraft.cut_copper_stairs": "Виточені мідні сходи",
  "block.minecraft.cut_red_sandstone": "Виточений черлений пісковик",
  "block.minecraft.cut_red_sandstone_slab": "Виточена черлена пісковикова плита",
  "block.minecraft.cut_sandstone": "Виточений пісковик",
  "block.minecraft.cut_sandstone_slab": "Виточена пісковикова плита",
  "block.minecraft.cyan_banner": "Морска фана",
  "block.minecraft.cyan_bed": "Морске ліжко",
  "block.minecraft.cyan_candle": "Морска сьвічка",
  "block.minecraft.cyan_candle_cake": "Пляцок зо морсков сьвічков",
  "block.minecraft.cyan_carpet": "Морский хідник",
  "block.minecraft.cyan_concrete": "Морский бетон",
  "block.minecraft.cyan_concrete_powder": "Морский цїмент",
  "block.minecraft.cyan_glazed_terracotta": "Морска поливєна печина",
  "block.minecraft.cyan_shulker_box": "Морске шулькер-пудевко",
  "block.minecraft.cyan_stained_glass": "Морске шкло",
  "block.minecraft.cyan_stained_glass_pane": "Морска шиба",
  "block.minecraft.cyan_terracotta": "Морска печина",
  "block.minecraft.cyan_wool": "Морска вовна",
  "block.minecraft.damaged_anvil": "Потовчене ковадло",
  "block.minecraft.dandelion": "Кульбаба",
  "block.minecraft.dark_oak_button": "Темнєкова кнопка",
  "block.minecraft.dark_oak_door": "Темнєкові двери",
  "block.minecraft.dark_oak_fence": "Темнєковий пліт",
  "block.minecraft.dark_oak_fence_gate": "Темнєкова фіртка",
  "block.minecraft.dark_oak_hanging_sign": "Темнєкова вивіска",
  "block.minecraft.dark_oak_leaves": "Темнєкове листє",
  "block.minecraft.dark_oak_log": "Темнєкова ковбицє",
  "block.minecraft.dark_oak_planks": "Темнєкові дошки",
  "block.minecraft.dark_oak_pressure_plate": "Темнєкова наступна плита",
  "block.minecraft.dark_oak_sapling": "Темнєкова дубова щіпа",
  "block.minecraft.dark_oak_shelf": "Темнєкова полицє",
  "block.minecraft.dark_oak_sign": "Темнєковий знак",
  "block.minecraft.dark_oak_slab": "Темнєкова плита",
  "block.minecraft.dark_oak_stairs": "Темнєкові сходи",
  "block.minecraft.dark_oak_trapdoor": "Темнєкова ляда",
  "block.minecraft.dark_oak_wall_hanging_sign": "Темнєкова стїна вивіска",
  "block.minecraft.dark_oak_wall_sign": "Темнєковий стїний знак",
  "block.minecraft.dark_oak_wood": "Темнєкове дерево",
  "block.minecraft.dark_prismarine": "Темний призмарин",
  "block.minecraft.dark_prismarine_slab": "Темна призмаринова плита",
  "block.minecraft.dark_prismarine_stairs": "Темні призмаринові сходи",
  "block.minecraft.daylight_detector": "Детектор деного сьвітла",
  "block.minecraft.dead_brain_coral": "Мертвий мозґовий кораль",
  "block.minecraft.dead_brain_coral_block": "Бльок мертвого мозґового коралє",
  "block.minecraft.dead_brain_coral_fan": "Мертвий мозґовий кораль-вахлєр",
  "block.minecraft.dead_brain_coral_wall_fan": "Мертвий настїний мозґовий кораль-вахлєр",
  "block.minecraft.dead_bubble_coral": "Мертвий бульковий кораль",
  "block.minecraft.dead_bubble_coral_block": "Бльок мертвого булькового коралє",
  "block.minecraft.dead_bubble_coral_fan": "Мертвий бульковий кораль-вахлєр",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мертвий настїний бульковий кораль-вахлєр",
  "block.minecraft.dead_bush": "Корч",
  "block.minecraft.dead_fire_coral": "Мертвий вогнєвий кораль",
  "block.minecraft.dead_fire_coral_block": "Бльок мертвого вогнєвого коралє",
  "block.minecraft.dead_fire_coral_fan": "Мертвий вогнєвий кораль-вахлєр",
  "block.minecraft.dead_fire_coral_wall_fan": "Мертвий настїний вогнєвий кораль-вахлєр",
  "block.minecraft.dead_horn_coral": "Мертвий роговий кораль",
  "block.minecraft.dead_horn_coral_block": "Бльок мертвого рогового коралє",
  "block.minecraft.dead_horn_coral_fan": "Мертвий роговий кораль-вахлєр",
  "block.minecraft.dead_horn_coral_wall_fan": "Мертвий настїний роговий кораль-вахлєр",
  "block.minecraft.dead_tube_coral": "Мертвий трубчєстий кораль",
  "block.minecraft.dead_tube_coral_block": "Бльок мертвого трубчєстого коралє",
  "block.minecraft.dead_tube_coral_fan": "Мертвий трубчєстий кораль-вахлєр",
  "block.minecraft.dead_tube_coral_wall_fan": "Мертвий настїний трубчєстий кораль-вахлєр",
  "block.minecraft.decorated_pot": "Воздоблений вазонок",
  "block.minecraft.deepslate": "Лупец",
  "block.minecraft.deepslate_brick_slab": "Лупцева цеглєна плита",
  "block.minecraft.deepslate_brick_stairs": "Лупцеві цеглєні сходи",
  "block.minecraft.deepslate_brick_wall": "Лупцевий цеглєний мур",
  "block.minecraft.deepslate_bricks": "Лупцева цегла",
  "block.minecraft.deepslate_coal_ore": "Лупцева вугільна руда",
  "block.minecraft.deepslate_copper_ore": "Лупцева мідна руда",
  "block.minecraft.deepslate_diamond_ore": "Лупцева диямантова руда",
  "block.minecraft.deepslate_emerald_ore": "Лупцева шмараґдова руда",
  "block.minecraft.deepslate_gold_ore": "Лупцева золота руда",
  "block.minecraft.deepslate_iron_ore": "Лупцева дзелїзна руда",
  "block.minecraft.deepslate_lapis_ore": "Лупцева лязуритова руда",
  "block.minecraft.deepslate_redstone_ore": "Лупцева редстовнова руда",
  "block.minecraft.deepslate_tile_slab": "Лупцева кафельна плита",
  "block.minecraft.deepslate_tile_stairs": "Лупцеві кафельні сходи",
  "block.minecraft.deepslate_tile_wall": "Лупцевий кафельний мур",
  "block.minecraft.deepslate_tiles": "Лупцевий кафель",
  "block.minecraft.detector_rail": "Штрека-детектор",
  "block.minecraft.diamond_block": "Бльок диямантів",
  "block.minecraft.diamond_ore": "Диямантова руда",
  "block.minecraft.diorite": "Дийорит",
  "block.minecraft.diorite_slab": "Дийоритова плита",
  "block.minecraft.diorite_stairs": "Дийоритові сходи",
  "block.minecraft.diorite_wall": "Дийоритовий мур",
  "block.minecraft.dirt": "Землє",
  "block.minecraft.dirt_path": "Стежка",
  "block.minecraft.dispenser": "Роздавач",
  "block.minecraft.dragon_egg": "Яйце зьмія",
  "block.minecraft.dragon_head": "Голова зьмія",
  "block.minecraft.dragon_wall_head": "Стїна голова зьмія",
  "block.minecraft.dried_ghast": "Засушений ґаст",
  "block.minecraft.dried_kelp_block": "Бльок сушеної лямінариї",
  "block.minecraft.dripstone_block": "Бльок глуболупака",
  "block.minecraft.dropper": "Вимітувач",
  "block.minecraft.emerald_block": "Бльок шмараґда",
  "block.minecraft.emerald_ore": "Шмараґдова руда",
  "block.minecraft.enchanting_table": "Стіл примівок",
  "block.minecraft.end_gateway": "Єнд-брама",
  "block.minecraft.end_portal": "Єнд-портал",
  "block.minecraft.end_portal_frame": "Рамка єнд-портала",
  "block.minecraft.end_rod": "Єнд-патик",
  "block.minecraft.end_stone": "Єнд-камінь",
  "block.minecraft.end_stone_brick_slab": "Єнд-камнєна цеглєна плита",
  "block.minecraft.end_stone_brick_stairs": "Єнд-камнєні цеглєні сходи",
  "block.minecraft.end_stone_brick_wall": "Єнд-камнєний цеглєний мур",
  "block.minecraft.end_stone_bricks": "Єнд-камнєна цегла",
  "block.minecraft.ender_chest": "Єндер-куфер",
  "block.minecraft.exposed_chiseled_copper": "Потемнїла різьблена мідь",
  "block.minecraft.exposed_copper": "Потемнїла мідь",
  "block.minecraft.exposed_copper_bars": "Потемнїлі мідні ґрати",
  "block.minecraft.exposed_copper_bulb": "Потемнїла мідна лямпа",
  "block.minecraft.exposed_copper_chain": "Потемнїлий мідний ланц",
  "block.minecraft.exposed_copper_chest": "Потемнїлий мідний куфер",
  "block.minecraft.exposed_copper_door": "Потемнїлі мідні двери",
  "block.minecraft.exposed_copper_golem_statue": "Потемнїла статуя мідного ґолєма",
  "block.minecraft.exposed_copper_grate": "Потемнїла мідна решітка",
  "block.minecraft.exposed_copper_lantern": "Потемнїла мідна лямпа",
  "block.minecraft.exposed_copper_trapdoor": "Потемнїла мідна ляда",
  "block.minecraft.exposed_cut_copper": "Потемнїла виточена мідь",
  "block.minecraft.exposed_cut_copper_slab": "Потемнїла виточена мідна плита",
  "block.minecraft.exposed_cut_copper_stairs": "Потемнїлі виточені мідні сходи",
  "block.minecraft.exposed_lightning_rod": "Потемнїлий громовід",
  "block.minecraft.farmland": "Рілє",
  "block.minecraft.fern": "Папоротник",
  "block.minecraft.fire": "Вогень",
  "block.minecraft.fire_coral": "Вогнєвий кораль",
  "block.minecraft.fire_coral_block": "Бльок вогнєвого коралє",
  "block.minecraft.fire_coral_fan": "Вогнєвий кораль-вахлєр",
  "block.minecraft.fire_coral_wall_fan": "Настїний вогнєвий кораль-вахлєр",
  "block.minecraft.firefly_bush": "Корч зо сьвітлєками",
  "block.minecraft.fletching_table": "Стіл стрільби",
  "block.minecraft.flower_pot": "Вазонок",
  "block.minecraft.flowering_azalea": "Цьвітуча газалїя",
  "block.minecraft.flowering_azalea_leaves": "Цьвітове газалїйове листє",
  "block.minecraft.frogspawn": "Жєбини",
  "block.minecraft.frosted_ice": "Талий лїд",
  "block.minecraft.furnace": "Пєц",
  "block.minecraft.gilded_blackstone": "Позолочений чорнокамінь",
  "block.minecraft.glass": "Шкло",
  "block.minecraft.glass_pane": "Шиба",
  "block.minecraft.glow_lichen": "Сьвітлолишєйник",
  "block.minecraft.glowstone": "Сьвітлокамінь",
  "block.minecraft.gold_block": "Бльок золота",
  "block.minecraft.gold_ore": "Золота руда",
  "block.minecraft.golden_dandelion": "Золота кульбаба",
  "block.minecraft.granite": "Ґранїт",
  "block.minecraft.granite_slab": "Ґранїтова плита",
  "block.minecraft.granite_stairs": "Ґранїтові сходи",
  "block.minecraft.granite_wall": "Ґранїтовий мур",
  "block.minecraft.grass": "Трава",
  "block.minecraft.grass_block": "Бльок трави",
  "block.minecraft.gravel": "Рінь",
  "block.minecraft.gray_banner": "Сїра фана",
  "block.minecraft.gray_bed": "Сїре ліжко",
  "block.minecraft.gray_candle": "Сїра сьвічка",
  "block.minecraft.gray_candle_cake": "Пляцок зо сїров сьвічков",
  "block.minecraft.gray_carpet": "Сїрий хідник",
  "block.minecraft.gray_concrete": "Сїрий бетон",
  "block.minecraft.gray_concrete_powder": "Сїрий цїмент",
  "block.minecraft.gray_glazed_terracotta": "Сїра поливєна печина",
  "block.minecraft.gray_shulker_box": "Сїре шулькер-пудевко",
  "block.minecraft.gray_stained_glass": "Сїре шкло",
  "block.minecraft.gray_stained_glass_pane": "Сїра шиба",
  "block.minecraft.gray_terracotta": "Сїра печина",
  "block.minecraft.gray_wool": "Сїра вовна",
  "block.minecraft.green_banner": "Дзелена фана",
  "block.minecraft.green_bed": "Дзелене ліжко",
  "block.minecraft.green_candle": "Дзелена сьвічка",
  "block.minecraft.green_candle_cake": "Пляцок з дзеленов сьвічков",
  "block.minecraft.green_carpet": "Дзелений хідник",
  "block.minecraft.green_concrete": "Дзелений бетон",
  "block.minecraft.green_concrete_powder": "Дзелений цїмент",
  "block.minecraft.green_glazed_terracotta": "Дзелена поливєна печина",
  "block.minecraft.green_shulker_box": "Дзелене шулькер-пудевко",
  "block.minecraft.green_stained_glass": "Дзелене шкло",
  "block.minecraft.green_stained_glass_pane": "Дзелена шиба",
  "block.minecraft.green_terracotta": "Дзелена печина",
  "block.minecraft.green_wool": "Дзелена вовна",
  "block.minecraft.grindstone": "Точило",
  "block.minecraft.hanging_roots": "Звисаюче корінє",
  "block.minecraft.hay_block": "Копицє сїна",
  "block.minecraft.heavy_core": "Тєжке ядро",
  "block.minecraft.heavy_weighted_pressure_plate": "Дзелїзна наступна плита",
  "block.minecraft.honey_block": "Бльок меда",
  "block.minecraft.honeycomb_block": "Бльок медових стільників",
  "block.minecraft.hopper": "Лїйка",
  "block.minecraft.horn_coral": "Роговий кораль",
  "block.minecraft.horn_coral_block": "Бльок рогового коралє",
  "block.minecraft.horn_coral_fan": "Мертвий роговий кораль-вахлєр",
  "block.minecraft.horn_coral_wall_fan": "Настїний роговий кораль-вахлєр",
  "block.minecraft.ice": "Лїд",
  "block.minecraft.infested_chiseled_stone_bricks": "Заражена різьблена камнєна цегла",
  "block.minecraft.infested_cobblestone": "Заражений бут",
  "block.minecraft.infested_cracked_stone_bricks": "Заражена тріснута камнєна цегла",
  "block.minecraft.infested_deepslate": "Лупцевий глуболупак",
  "block.minecraft.infested_mossy_stone_bricks": "Заражена мохова камнєна цегла",
  "block.minecraft.infested_stone": "Заражений камінь",
  "block.minecraft.infested_stone_bricks": "Заражена камнєна цегла",
  "block.minecraft.iron_bars": "Дзелїзні ґрати",
  "block.minecraft.iron_block": "Бльок дзелїза",
  "block.minecraft.iron_chain": "Дзелїзний ланц",
  "block.minecraft.iron_door": "Дзелїзні двери",
  "block.minecraft.iron_ore": "Дзелїзна руда",
  "block.minecraft.iron_trapdoor": "Дзелїзна ляда",
  "block.minecraft.jack_o_lantern": "Джеків сьвітильник",
  "block.minecraft.jigsaw": "Бльок пузлїв",
  "block.minecraft.jukebox": "Радейко",
  "block.minecraft.jungle_button": "Джунґльова кнопка",
  "block.minecraft.jungle_door": "Джунґльові двери",
  "block.minecraft.jungle_fence": "Джунґльовий пліт",
  "block.minecraft.jungle_fence_gate": "Джунґльова фіртка",
  "block.minecraft.jungle_hanging_sign": "Джунґльова вивіска",
  "block.minecraft.jungle_leaves": "Джунґльове листє",
  "block.minecraft.jungle_log": "Джунґльова ковбицє",
  "block.minecraft.jungle_planks": "Джунґльові дошки",
  "block.minecraft.jungle_pressure_plate": "Джунґльова наступна плита",
  "block.minecraft.jungle_sapling": "Джунґльова щіпа",
  "block.minecraft.jungle_shelf": "Джунґльова полицє",
  "block.minecraft.jungle_sign": "Джунґльовий знак",
  "block.minecraft.jungle_slab": "Джунґльова плита",
  "block.minecraft.jungle_stairs": "Джунґльові сходи",
  "block.minecraft.jungle_trapdoor": "Джунґльова ляда",
  "block.minecraft.jungle_wall_hanging_sign": "Джунґльова стїна вивіска",
  "block.minecraft.jungle_wall_sign": "Джунґльовий стїний знак",
  "block.minecraft.jungle_wood": "Джунґльове дерево",
  "block.minecraft.kelp": "Лямінария",
  "block.minecraft.kelp_plant": "Бадилє лямінариї",
  "block.minecraft.ladder": "Драбина",
  "block.minecraft.lantern": "Лямпа",
  "block.minecraft.lapis_block": "Бльок лязурита",
  "block.minecraft.lapis_ore": "Лязуритова руда",
  "block.minecraft.large_amethyst_bud": "Грубий вометистовий зародок",
  "block.minecraft.large_fern": "Великий папоротник",
  "block.minecraft.lava": "Лява",
  "block.minecraft.lava_cauldron": "Саганок з лявов",
  "block.minecraft.leaf_litter": "Впале листє",
  "block.minecraft.lectern": "Лєктория",
  "block.minecraft.lever": "Важіль",
  "block.minecraft.light": "Сьвітло",
  "block.minecraft.light_blue_banner": "Голуба фана",
  "block.minecraft.light_blue_bed": "Голубе ліжко",
  "block.minecraft.light_blue_candle": "Голуба сьвічка",
  "block.minecraft.light_blue_candle_cake": "Пляцок зо голубов сьвічков",
  "block.minecraft.light_blue_carpet": "Голубий хідник",
  "block.minecraft.light_blue_concrete": "Голубий бетон",
  "block.minecraft.light_blue_concrete_powder": "Голубий цїмент",
  "block.minecraft.light_blue_glazed_terracotta": "Голуба поливєна печина",
  "block.minecraft.light_blue_shulker_box": "Голубе шулькер-пудевко",
  "block.minecraft.light_blue_stained_glass": "Голубе шкло",
  "block.minecraft.light_blue_stained_glass_pane": "Голуба шиба",
  "block.minecraft.light_blue_terracotta": "Голуба печина",
  "block.minecraft.light_blue_wool": "Голуба вовна",
  "block.minecraft.light_gray_banner": "Крицева фана",
  "block.minecraft.light_gray_bed": "Крицеве ліжко",
  "block.minecraft.light_gray_candle": "Крицева сьвічка",
  "block.minecraft.light_gray_candle_cake": "Пляцок зо крицевов сьвічков",
  "block.minecraft.light_gray_carpet": "Крицевий хідник",
  "block.minecraft.light_gray_concrete": "Крицевий бетон",
  "block.minecraft.light_gray_concrete_powder": "Крицевий цїмент",
  "block.minecraft.light_gray_glazed_terracotta": "Крицева поливєна печина",
  "block.minecraft.light_gray_shulker_box": "Крицеве шулькер-пудевко",
  "block.minecraft.light_gray_stained_glass": "Крицеве шкло",
  "block.minecraft.light_gray_stained_glass_pane": "Крицева шиба",
  "block.minecraft.light_gray_terracotta": "Крицева печина",
  "block.minecraft.light_gray_wool": "Крицева вовна",
  "block.minecraft.light_weighted_pressure_plate": "Золота наступна плита",
  "block.minecraft.lightning_rod": "Громовід",
  "block.minecraft.lilac": "Боз",
  "block.minecraft.lily_of_the_valley": "Дзвоники",
  "block.minecraft.lily_pad": "Лїлея",
  "block.minecraft.lime_banner": "Салатова фана",
  "block.minecraft.lime_bed": "Салатове ліжко",
  "block.minecraft.lime_candle": "Салатова сьвічка",
  "block.minecraft.lime_candle_cake": "Пляцок зо салатовов сьвічков",
  "block.minecraft.lime_carpet": "Салатовий хідник",
  "block.minecraft.lime_concrete": "Салатовий бетон",
  "block.minecraft.lime_concrete_powder": "Салатовий цїмент",
  "block.minecraft.lime_glazed_terracotta": "Салатова поливєна печина",
  "block.minecraft.lime_shulker_box": "Салатове шулькер-пудевко",
  "block.minecraft.lime_stained_glass": "Салатове шкло",
  "block.minecraft.lime_stained_glass_pane": "Салатова шиба",
  "block.minecraft.lime_terracotta": "Салатова теракота",
  "block.minecraft.lime_wool": "Салатова вовна",
  "block.minecraft.lodestone": "Маґнекамінь",
  "block.minecraft.loom": "Ткацкий варстат",
  "block.minecraft.magenta_banner": "Фукзиєва фана",
  "block.minecraft.magenta_bed": "Фукзиєве ліжко",
  "block.minecraft.magenta_candle": "Фукзиєва сьвічка",
  "block.minecraft.magenta_candle_cake": "Пляцок з фукзиєвов сьвічков",
  "block.minecraft.magenta_carpet": "Фукзиєвий хідник",
  "block.minecraft.magenta_concrete": "Фукзиєвий бетон",
  "block.minecraft.magenta_concrete_powder": "Фукзиєвий цїмент",
  "block.minecraft.magenta_glazed_terracotta": "Фукзиєва поливєна печина",
  "block.minecraft.magenta_shulker_box": "Фукзиєве шулькер-пудевко",
  "block.minecraft.magenta_stained_glass": "Фукзиєве шкло",
  "block.minecraft.magenta_stained_glass_pane": "Фукзиєва шиба",
  "block.minecraft.magenta_terracotta": "Фукзиєва печина",
  "block.minecraft.magenta_wool": "Фукзиєва вовна",
  "block.minecraft.magma_block": "Бльок маґми",
  "block.minecraft.mangrove_button": "Манґровна кнопка",
  "block.minecraft.mangrove_door": "Манґровні двери",
  "block.minecraft.mangrove_fence": "Манґровний пліт",
  "block.minecraft.mangrove_fence_gate": "Манґровна фіртка",
  "block.minecraft.mangrove_hanging_sign": "Манґровна вивіска",
  "block.minecraft.mangrove_leaves": "Манґровне листє",
  "block.minecraft.mangrove_log": "Манґровна ковбицє",
  "block.minecraft.mangrove_planks": "Манґровні дошки",
  "block.minecraft.mangrove_pressure_plate": "Манґровна наступна плита",
  "block.minecraft.mangrove_propagule": "Манґровна щіпа",
  "block.minecraft.mangrove_roots": "Манґровне корінє",
  "block.minecraft.mangrove_shelf": "Манґровна полицє",
  "block.minecraft.mangrove_sign": "Манґровний знак",
  "block.minecraft.mangrove_slab": "Манґровна плита",
  "block.minecraft.mangrove_stairs": "Манґровні сходи",
  "block.minecraft.mangrove_trapdoor": "Манґровна ляда",
  "block.minecraft.mangrove_wall_hanging_sign": "Манґровна стїна вивіска",
  "block.minecraft.mangrove_wall_sign": "Манґровний стїний знак",
  "block.minecraft.mangrove_wood": "Манґровне дерево",
  "block.minecraft.medium_amethyst_bud": "Середний вометистовий зародок",
  "block.minecraft.melon": "Кавун",
  "block.minecraft.melon_stem": "Бадилє кавуна",
  "block.minecraft.moss_block": "Бльок моху",
  "block.minecraft.moss_carpet": "Моховий хідник",
  "block.minecraft.mossy_cobblestone": "Моховий бут",
  "block.minecraft.mossy_cobblestone_slab": "Мохова бутова плита",
  "block.minecraft.mossy_cobblestone_stairs": "Мохові бутові сходи",
  "block.minecraft.mossy_cobblestone_wall": "Моховий бутовий мур",
  "block.minecraft.mossy_stone_brick_slab": "Мохова камнєна цеглєна плита",
  "block.minecraft.mossy_stone_brick_stairs": "Мохові камнєні цеглєні сходи",
  "block.minecraft.mossy_stone_brick_wall": "Моховий камнєний цеглєний мур",
  "block.minecraft.mossy_stone_bricks": "Мохова камнєна цегла",
  "block.minecraft.moving_piston": "Рухомий товкач",
  "block.minecraft.mud": "Мокравина",
  "block.minecraft.mud_brick_slab": "Мокравина цеглєна плита",
  "block.minecraft.mud_brick_stairs": "Мокравині цеглєні сходи",
  "block.minecraft.mud_brick_wall": "Мокравиний цеглєний мур",
  "block.minecraft.mud_bricks": "Мокравина цегла",
  "block.minecraft.muddy_mangrove_roots": "Мокравине манґровне корінє",
  "block.minecraft.mushroom_stem": "Бадилє губи",
  "block.minecraft.mycelium": "Грибницє",
  "block.minecraft.nether_brick_fence": "Недерский цеглєний пліт",
  "block.minecraft.nether_brick_slab": "Недерска цеглєна плита",
  "block.minecraft.nether_brick_stairs": "Недерскі цеглєні сходи",
  "block.minecraft.nether_brick_wall": "Недерский цеглєний мур",
  "block.minecraft.nether_bricks": "Недерска цегла",
  "block.minecraft.nether_gold_ore": "Недерска золота руда",
  "block.minecraft.nether_portal": "Недер-порталь",
  "block.minecraft.nether_quartz_ore": "Недерска кварцова руда",
  "block.minecraft.nether_sprouts": "Недерскі памолодки",
  "block.minecraft.nether_wart": "Недерскі пипки",
  "block.minecraft.nether_wart_block": "Бльок недерских пипок",
  "block.minecraft.netherite_block": "Бльок недерита",
  "block.minecraft.netherrack": "Недерек",
  "block.minecraft.note_block": "Бльок нут",
  "block.minecraft.oak_button": "Дубова кнопка",
  "block.minecraft.oak_door": "Дубові двери",
  "block.minecraft.oak_fence": "Дубовий пліт",
  "block.minecraft.oak_fence_gate": "Дубова фіртка",
  "block.minecraft.oak_hanging_sign": "Дубова вивіска",
  "block.minecraft.oak_leaves": "Дубове листє",
  "block.minecraft.oak_log": "Дубова ковбицє",
  "block.minecraft.oak_planks": "Дубові дошки",
  "block.minecraft.oak_pressure_plate": "Дубова наступна плита",
  "block.minecraft.oak_sapling": "Дубова щіпа",
  "block.minecraft.oak_shelf": "Дубова полицє",
  "block.minecraft.oak_sign": "Дубовий знак",
  "block.minecraft.oak_slab": "Дубова плита",
  "block.minecraft.oak_stairs": "Дубові сходи",
  "block.minecraft.oak_trapdoor": "Дубова ляда",
  "block.minecraft.oak_wall_hanging_sign": "Дубова стїна вивіска",
  "block.minecraft.oak_wall_sign": "Дубовий стїний знак",
  "block.minecraft.oak_wood": "Дубове дерево",
  "block.minecraft.observer": "Приглєдник",
  "block.minecraft.obsidian": "Вобсидиян",
  "block.minecraft.ochre_froglight": "Вохриста жєблєча лямпа",
  "block.minecraft.ominous_banner": "Зла фана",
  "block.minecraft.open_eyeblossom": "Втворений вочкоцьвіт",
  "block.minecraft.orange_banner": "Цеглова фана",
  "block.minecraft.orange_bed": "Цеглове ліжко",
  "block.minecraft.orange_candle": "Цеглова сьвічка",
  "block.minecraft.orange_candle_cake": "Пляцок зо цегловов сьвічков",
  "block.minecraft.orange_carpet": "Цегловий хідник",
  "block.minecraft.orange_concrete": "Цегловий бетон",
  "block.minecraft.orange_concrete_powder": "Цегловий цїмент",
  "block.minecraft.orange_glazed_terracotta": "Цеглова поливєна печина",
  "block.minecraft.orange_shulker_box": "Цеглове шулькер-пудевко",
  "block.minecraft.orange_stained_glass": "Цеглове шкло",
  "block.minecraft.orange_stained_glass_pane": "Цеглова шиба",
  "block.minecraft.orange_terracotta": "Цеглова печина",
  "block.minecraft.orange_tulip": "Цегловий тюльпан",
  "block.minecraft.orange_wool": "Цеглова вовна",
  "block.minecraft.oxeye_daisy": "Королицє",
  "block.minecraft.oxidized_chiseled_copper": "Воксидована різьблена мідь",
  "block.minecraft.oxidized_copper": "Воксидована мідь",
  "block.minecraft.oxidized_copper_bars": "Воксидовані мідні ґрати",
  "block.minecraft.oxidized_copper_bulb": "Воксидована мідна лямпа",
  "block.minecraft.oxidized_copper_chain": "Воксидований мідний ланц",
  "block.minecraft.oxidized_copper_chest": "Воксидований мідний куфер",
  "block.minecraft.oxidized_copper_door": "Воксидовані мідні двери",
  "block.minecraft.oxidized_copper_golem_statue": "Воксидована статуя мідного ґолєма",
  "block.minecraft.oxidized_copper_grate": "Воксидована мідна решітка",
  "block.minecraft.oxidized_copper_lantern": "Воксидована мідна лямпа",
  "block.minecraft.oxidized_copper_trapdoor": "Воксидована мідна ляда",
  "block.minecraft.oxidized_cut_copper": "Воксидована виточена мідь",
  "block.minecraft.oxidized_cut_copper_slab": "Воксидована виточена мідна плита",
  "block.minecraft.oxidized_cut_copper_stairs": "Воксидовані виточені мідні сходи",
  "block.minecraft.oxidized_lightning_rod": "Воксидований громовід",
  "block.minecraft.packed_ice": "Грубий лїд",
  "block.minecraft.packed_mud": "Втромбована мокравина",
  "block.minecraft.pale_hanging_moss": "Блїдий висний мох",
  "block.minecraft.pale_moss_block": "Блїдий моховий бльок",
  "block.minecraft.pale_moss_carpet": "Блїдий моховий хідник",
  "block.minecraft.pale_oak_button": "Блїдєкова кнопка",
  "block.minecraft.pale_oak_door": "Блїдєкові двери",
  "block.minecraft.pale_oak_fence": "Блїдєковий пліт",
  "block.minecraft.pale_oak_fence_gate": "Блїдєкова фіртка",
  "block.minecraft.pale_oak_hanging_sign": "Блїдєкова вивіска",
  "block.minecraft.pale_oak_leaves": "Блїдєкове листє",
  "block.minecraft.pale_oak_log": "Блїдєкова ковбицє",
  "block.minecraft.pale_oak_planks": "Блїдєкові дошки",
  "block.minecraft.pale_oak_pressure_plate": "Блїдєкова наступна плита",
  "block.minecraft.pale_oak_sapling": "Блїдєкова щіпа",
  "block.minecraft.pale_oak_shelf": "Блїдєкова полицє",
  "block.minecraft.pale_oak_sign": "Блїдєковий знак",
  "block.minecraft.pale_oak_slab": "Блїдєкова плита",
  "block.minecraft.pale_oak_stairs": "Блїдєкові сходи",
  "block.minecraft.pale_oak_trapdoor": "Блїдєкова ляда",
  "block.minecraft.pale_oak_wall_hanging_sign": "Блїдєкова стїна вивіска",
  "block.minecraft.pale_oak_wall_sign": "Блїдєковий стїний знак",
  "block.minecraft.pale_oak_wood": "Блїдєкове дерево",
  "block.minecraft.pearlescent_froglight": "Перламутрова жєблєча лямпа",
  "block.minecraft.peony": "Пійон",
  "block.minecraft.petrified_oak_slab": "Скамєнїла дубова плита",
  "block.minecraft.piglin_head": "Голова піґлїна",
  "block.minecraft.piglin_wall_head": "Стїна голова піґлїна",
  "block.minecraft.pink_banner": "Ружова фана",
  "block.minecraft.pink_bed": "Ружове ліжко",
  "block.minecraft.pink_candle": "Ружова сьвічка",
  "block.minecraft.pink_candle_cake": "Пляцок зо ружовов сьвічков",
  "block.minecraft.pink_carpet": "Ружовий хідник",
  "block.minecraft.pink_concrete": "Ружовий бетон",
  "block.minecraft.pink_concrete_powder": "Ружовий цїмент",
  "block.minecraft.pink_glazed_terracotta": "Ружова поливєна печина",
  "block.minecraft.pink_petals": "Ружові пелюстки",
  "block.minecraft.pink_shulker_box": "Ружове шулькер-пудевко",
  "block.minecraft.pink_stained_glass": "Ружове шкло",
  "block.minecraft.pink_stained_glass_pane": "Ружова шиба",
  "block.minecraft.pink_terracotta": "Ружова печина",
  "block.minecraft.pink_tulip": "Ружовий тюльпан",
  "block.minecraft.pink_wool": "Ружова вовна",
  "block.minecraft.piston": "Товкач",
  "block.minecraft.piston_head": "Голова товкачє",
  "block.minecraft.pitcher_crop": "Старолїтне насїнє",
  "block.minecraft.pitcher_plant": "Дзбанок",
  "block.minecraft.player_head": "Голова бавцє",
  "block.minecraft.player_head.named": "Голова %s",
  "block.minecraft.player_wall_head": "Стїна голова бавцє",
  "block.minecraft.podzol": "Підзол",
  "block.minecraft.pointed_dripstone": "Завострений капельник",
  "block.minecraft.polished_andesite": "Ґлянцований гандезит",
  "block.minecraft.polished_andesite_slab": "Ґлянцована гандезитова плита",
  "block.minecraft.polished_andesite_stairs": "Ґлянцовані гандезитові сходи",
  "block.minecraft.polished_basalt": "Ґлянцований базальт",
  "block.minecraft.polished_blackstone": "Ґлянцований чорнокамінь",
  "block.minecraft.polished_blackstone_brick_slab": "Ґлянцована чорнокамнєна цеглєна плита",
  "block.minecraft.polished_blackstone_brick_stairs": "Ґлянцовані чорнокамнєні цеглєні сходи",
  "block.minecraft.polished_blackstone_brick_wall": "Ґлянцований чорнокамнєний цеглєний мур",
  "block.minecraft.polished_blackstone_bricks": "Ґлянцована чорнокамнєна цегла",
  "block.minecraft.polished_blackstone_button": "Ґлянцована чорнокамнєна кнопка",
  "block.minecraft.polished_blackstone_pressure_plate": "Ґлянцована чорнокамнєна наступна плита",
  "block.minecraft.polished_blackstone_slab": "Ґлянцована чорнокамнєна плита",
  "block.minecraft.polished_blackstone_stairs": "Ґлянцовані чорнокамнєні сходи",
  "block.minecraft.polished_blackstone_wall": "Ґлянцований чорнокамнєний мур",
  "block.minecraft.polished_deepslate": "Ґлянцований лупец",
  "block.minecraft.polished_deepslate_slab": "Ґлянцована лупцева плита",
  "block.minecraft.polished_deepslate_stairs": "Ґлянцовані лупцеві сходи",
  "block.minecraft.polished_deepslate_wall": "Ґлянцований лупцевий мур",
  "block.minecraft.polished_diorite": "Ґлянцований дийорит",
  "block.minecraft.polished_diorite_slab": "Ґлянцована дийоритова плита",
  "block.minecraft.polished_diorite_stairs": "Ґлянцовані дийоритові сходи",
  "block.minecraft.polished_granite": "Ґлянцований ґранїт",
  "block.minecraft.polished_granite_slab": "Ґлянцована ґранїтова плита",
  "block.minecraft.polished_granite_stairs": "Ґлянцовані ґранїтові сходи",
  "block.minecraft.polished_tuff": "Ґлянцований туф",
  "block.minecraft.polished_tuff_slab": "Ґлянцована туфова плита",
  "block.minecraft.polished_tuff_stairs": "Ґлянцовані туфові сходи",
  "block.minecraft.polished_tuff_wall": "Ґлянцований туфовий мур",
  "block.minecraft.poppy": "Мак",
  "block.minecraft.potatoes": "Бараболє",
  "block.minecraft.potted_acacia_sapling": "Вазонок з терностручовов щіпов",
  "block.minecraft.potted_allium": "Вазонок з трамбухов",
  "block.minecraft.potted_azalea_bush": "Вазонок з газалїйов",
  "block.minecraft.potted_azure_bluet": "Вазонок з польовов ромашков",
  "block.minecraft.potted_bamboo": "Вазонок з бамбусом",
  "block.minecraft.potted_birch_sapling": "Вазонок з березовов щіпов",
  "block.minecraft.potted_blue_orchid": "Вазонок з синим зазулинцем",
  "block.minecraft.potted_brown_mushroom": "Вазонок з брунатнов губов",
  "block.minecraft.potted_cactus": "Вазонок зо мнєжнем",
  "block.minecraft.potted_cherry_sapling": "Вазонок з вишневов щіпов",
  "block.minecraft.potted_closed_eyeblossom": "Вазонок зо затвореним вокоцьвітков",
  "block.minecraft.potted_cornflower": "Вазонок зо синоцьвітом",
  "block.minecraft.potted_crimson_fungus": "Вазонок з багровов губов",
  "block.minecraft.potted_crimson_roots": "Вазонок з багровим коріньом",
  "block.minecraft.potted_dandelion": "Вазонок з кульбабов",
  "block.minecraft.potted_dark_oak_sapling": "Вазонок з темнодубовов щіпов",
  "block.minecraft.potted_dead_bush": "Вазонок з корчом",
  "block.minecraft.potted_fern": "Вазонок зо папоротьов",
  "block.minecraft.potted_flowering_azalea_bush": "Вазонок зо цьвітучов газалїйов",
  "block.minecraft.potted_golden_dandelion": "Вазонок зі золотов кульбабов",
  "block.minecraft.potted_jungle_sapling": "Вазонок з джунґльовов щіпов",
  "block.minecraft.potted_lily_of_the_valley": "Вазонок з дзвониками",
  "block.minecraft.potted_mangrove_propagule": "Вазонок зо манґровнов щіпов",
  "block.minecraft.potted_oak_sapling": "Вазонок зо дубовов щіпов",
  "block.minecraft.potted_open_eyeblossom": "Вазонок з втвореним вочкоцьвітом",
  "block.minecraft.potted_orange_tulip": "Вазонок зо цегловим тюльпаном",
  "block.minecraft.potted_oxeye_daisy": "Вазонок з королицев",
  "block.minecraft.potted_pale_oak_sapling": "Вазанок з блїдов дубов щіпов",
  "block.minecraft.potted_pink_tulip": "Вазонок зо ружовим тюльпаном",
  "block.minecraft.potted_poppy": "Вазонок з маком",
  "block.minecraft.potted_red_mushroom": "Вазонок з черленов губов",
  "block.minecraft.potted_red_tulip": "Вазонок зо черленим тюльпаном",
  "block.minecraft.potted_spruce_sapling": "Вазонок зо смерековов щіпов",
  "block.minecraft.potted_torchflower": "Вазонок зо смолоцьвітником",
  "block.minecraft.potted_warped_fungus": "Вазонок з покрученов губов",
  "block.minecraft.potted_warped_roots": "Вазонок з покрученим коріньом",
  "block.minecraft.potted_white_tulip": "Вазонок з білим тюльпаном",
  "block.minecraft.potted_wither_rose": "Вазонок з ружов відера",
  "block.minecraft.powder_snow": "Пухкий снїг",
  "block.minecraft.powder_snow_cauldron": "Саганок з пухким снїгом",
  "block.minecraft.powered_rail": "Штрека-єлектрична",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Призмаринова цеглєна плита",
  "block.minecraft.prismarine_brick_stairs": "Призмаринові цеглєні сходи",
  "block.minecraft.prismarine_bricks": "Призмаринова цегла",
  "block.minecraft.prismarine_slab": "Призмаринова плита",
  "block.minecraft.prismarine_stairs": "Призмаринові сходи",
  "block.minecraft.prismarine_wall": "Призмариновий мур",
  "block.minecraft.pumpkin": "Гарбуз",
  "block.minecraft.pumpkin_stem": "Гарбузове бадилє",
  "block.minecraft.purple_banner": "Фійолєтова фана",
  "block.minecraft.purple_bed": "Фійолєтове ліжко",
  "block.minecraft.purple_candle": "Фійолєтова сьвічка",
  "block.minecraft.purple_candle_cake": "Пляцок з фійолєтовов сьвічков",
  "block.minecraft.purple_carpet": "Фійолєтовий хідник",
  "block.minecraft.purple_concrete": "Фійолєтовий бетон",
  "block.minecraft.purple_concrete_powder": "Фійолєтовий цїмент",
  "block.minecraft.purple_glazed_terracotta": "Фійолєтова поливєна печина",
  "block.minecraft.purple_shulker_box": "Фійолєтове шулькер-пудевко",
  "block.minecraft.purple_stained_glass": "Фійолєтове шкло",
  "block.minecraft.purple_stained_glass_pane": "Фійолєтова шиба",
  "block.minecraft.purple_terracotta": "Фійолєтова печина",
  "block.minecraft.purple_wool": "Фійолєтова вовна",
  "block.minecraft.purpur_block": "Бльок пурпура",
  "block.minecraft.purpur_pillar": "Пурпурова кольона",
  "block.minecraft.purpur_slab": "Пурпурова плита",
  "block.minecraft.purpur_stairs": "Пурпурові сходи",
  "block.minecraft.quartz_block": "Бльок кварца",
  "block.minecraft.quartz_bricks": "Кварцова цегла",
  "block.minecraft.quartz_pillar": "Кварцова кольона",
  "block.minecraft.quartz_slab": "Кварцова плита",
  "block.minecraft.quartz_stairs": "Кварцові сходи",
  "block.minecraft.rail": "Штрека",
  "block.minecraft.raw_copper_block": "Бльок невочищеної міди",
  "block.minecraft.raw_gold_block": "Бльок невочищеного золота",
  "block.minecraft.raw_iron_block": "Бльок невочищеного дзелїза",
  "block.minecraft.red_banner": "Черлена фана",
  "block.minecraft.red_bed": "Черлене ліжко",
  "block.minecraft.red_candle": "Черлена сьвічка",
  "block.minecraft.red_candle_cake": "Пляцок зо черленов сьвічков",
  "block.minecraft.red_carpet": "Черлений хідник",
  "block.minecraft.red_concrete": "Черлений бетон",
  "block.minecraft.red_concrete_powder": "Черлений цїмент",
  "block.minecraft.red_glazed_terracotta": "Черлена поливєна печина",
  "block.minecraft.red_mushroom": "Черлена губа",
  "block.minecraft.red_mushroom_block": "Бльок черлених губів",
  "block.minecraft.red_nether_brick_slab": "Черлена недерска цеглєна плита",
  "block.minecraft.red_nether_brick_stairs": "Черлені недерскі цеглєні сходи",
  "block.minecraft.red_nether_brick_wall": "Черлений недерский цеглєний мур",
  "block.minecraft.red_nether_bricks": "Черлена недерска цегла",
  "block.minecraft.red_sand": "Черлений пісок",
  "block.minecraft.red_sandstone": "Черлений пісковик",
  "block.minecraft.red_sandstone_slab": "Черлена пісковикова плита",
  "block.minecraft.red_sandstone_stairs": "Черлені пісковикові сходи",
  "block.minecraft.red_sandstone_wall": "Черлений пісковиковий мур",
  "block.minecraft.red_shulker_box": "Черлене шулькер-пудевко",
  "block.minecraft.red_stained_glass": "Черлене шкло",
  "block.minecraft.red_stained_glass_pane": "Черлена шиба",
  "block.minecraft.red_terracotta": "Черлена печина",
  "block.minecraft.red_tulip": "Черлений тюльпан",
  "block.minecraft.red_wool": "Черлена вовна",
  "block.minecraft.redstone_block": "Бльок редстовна",
  "block.minecraft.redstone_lamp": "Редстовнова лямпа",
  "block.minecraft.redstone_ore": "Редстовнова руда",
  "block.minecraft.redstone_torch": "Редстовновий смолоскіп",
  "block.minecraft.redstone_wall_torch": "Редстовновий настїний смолоскіп",
  "block.minecraft.redstone_wire": "Редстовновий дріт",
  "block.minecraft.reinforced_deepslate": "Змоцнений лупец",
  "block.minecraft.repeater": "Редстовновий повторєч",
  "block.minecraft.repeating_command_block": "Повторєючий наказовий бльок",
  "block.minecraft.resin_block": "Бльок смоли",
  "block.minecraft.resin_brick_slab": "Смолєна цеглєна плита",
  "block.minecraft.resin_brick_stairs": "Смолєні цеглєні сходи",
  "block.minecraft.resin_brick_wall": "Смолєний цеглєний мур",
  "block.minecraft.resin_bricks": "Смолєна цегла",
  "block.minecraft.resin_clump": "Кавальчик смоли",
  "block.minecraft.respawn_anchor": "Котвицє відроди",
  "block.minecraft.rooted_dirt": "Коріниста землє",
  "block.minecraft.rose_bush": "Ружа",
  "block.minecraft.sand": "Пісок",
  "block.minecraft.sandstone": "Пісковик",
  "block.minecraft.sandstone_slab": "Пісковикова плита",
  "block.minecraft.sandstone_stairs": "Пісковикові сходи",
  "block.minecraft.sandstone_wall": "Пісковиковий мур",
  "block.minecraft.scaffolding": "Риштовка",
  "block.minecraft.sculk": "Шкальк",
  "block.minecraft.sculk_catalyst": "Шкальковий каталїзатор",
  "block.minecraft.sculk_sensor": "Шкальковий сензор",
  "block.minecraft.sculk_shrieker": "Шкальковий верескун",
  "block.minecraft.sculk_vein": "Шкалькова жила",
  "block.minecraft.sea_lantern": "Морска лямпа",
  "block.minecraft.sea_pickle": "Морский вогирок",
  "block.minecraft.seagrass": "Морска трава",
  "block.minecraft.set_spawn": "Місце відроди виставлено",
  "block.minecraft.short_dry_grass": "Куца суха трава",
  "block.minecraft.short_grass": "Куца трава",
  "block.minecraft.shroomlight": "Сьвітлогуба",
  "block.minecraft.shulker_box": "Шулькер-пудевко",
  "block.minecraft.skeleton_skull": "Череп шкілєта",
  "block.minecraft.skeleton_wall_skull": "Настїний череп шкілєта",
  "block.minecraft.slime_block": "Слїзовий бльок",
  "block.minecraft.small_amethyst_bud": "Малий вометистий зародок",
  "block.minecraft.small_dripleaf": "Малий краполист",
  "block.minecraft.smithing_table": "Ковальский стіл",
  "block.minecraft.smoker": "Вудильнє",
  "block.minecraft.smooth_basalt": "Гладкий базальт",
  "block.minecraft.smooth_quartz": "Бльок гладкого кварца",
  "block.minecraft.smooth_quartz_slab": "Гладка кварцова плита",
  "block.minecraft.smooth_quartz_stairs": "Гладкі кварцові сходи",
  "block.minecraft.smooth_red_sandstone": "Гладкий черлений пісковик",
  "block.minecraft.smooth_red_sandstone_slab": "Гладка черлена пісковикова плита",
  "block.minecraft.smooth_red_sandstone_stairs": "Гладкі черлені пісковикові сходи",
  "block.minecraft.smooth_sandstone": "Гладкий пісковик",
  "block.minecraft.smooth_sandstone_slab": "Гладка пісковикова плита",
  "block.minecraft.smooth_sandstone_stairs": "Гладкі пісковикові сходи",
  "block.minecraft.smooth_stone": "Гладкий камінь",
  "block.minecraft.smooth_stone_slab": "Гладка камнєна плита",
  "block.minecraft.sniffer_egg": "Яйце нюхлиска",
  "block.minecraft.snow": "Снїг",
  "block.minecraft.snow_block": "Бльок снїга",
  "block.minecraft.soul_campfire": "Ватра душ",
  "block.minecraft.soul_fire": "Вогень душ",
  "block.minecraft.soul_lantern": "Лямпа душ",
  "block.minecraft.soul_sand": "Пісок душ",
  "block.minecraft.soul_soil": "Землє душ",
  "block.minecraft.soul_torch": "Смолоскіп душ",
  "block.minecraft.soul_wall_torch": "Настїний смолоскіп душ",
  "block.minecraft.spawn.not_valid": "В Вас нема ліжка ци наснаженої котвицї відроди, альбо вони сут неприступні",
  "block.minecraft.spawner": "Спавнер почварів",
  "block.minecraft.spawner.desc1": "Співдїя з яйцьом появи:",
  "block.minecraft.spawner.desc2": "Зазначєє тип моба",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Спороцьвіт",
  "block.minecraft.spruce_button": "Смерекова кнопка",
  "block.minecraft.spruce_door": "Смерекові двери",
  "block.minecraft.spruce_fence": "Смерековий пліт",
  "block.minecraft.spruce_fence_gate": "Смерекова фіртка",
  "block.minecraft.spruce_hanging_sign": "Смерекова вивіска",
  "block.minecraft.spruce_leaves": "Смерекове листє",
  "block.minecraft.spruce_log": "Смерекова ковбицє",
  "block.minecraft.spruce_planks": "Смерекові дошки",
  "block.minecraft.spruce_pressure_plate": "Смерекова наступна плита",
  "block.minecraft.spruce_sapling": "Смерекова щіпа",
  "block.minecraft.spruce_shelf": "Смерекова полицє",
  "block.minecraft.spruce_sign": "Смерековий знак",
  "block.minecraft.spruce_slab": "Смерекова плита",
  "block.minecraft.spruce_stairs": "Смерекові сходи",
  "block.minecraft.spruce_trapdoor": "Смерекова ляда",
  "block.minecraft.spruce_wall_hanging_sign": "Смерекова стїна вивіска",
  "block.minecraft.spruce_wall_sign": "Смерековий стїний знак",
  "block.minecraft.spruce_wood": "Смерекове дерево",
  "block.minecraft.sticky_piston": "Липкий товкач",
  "block.minecraft.stone": "Камінь",
  "block.minecraft.stone_brick_slab": "Камнєна цеглєна плита",
  "block.minecraft.stone_brick_stairs": "Камнєні цеглєні сходи",
  "block.minecraft.stone_brick_wall": "Камнєний цеглєний мур",
  "block.minecraft.stone_bricks": "Камнєна цегла",
  "block.minecraft.stone_button": "Камнєна кнопка",
  "block.minecraft.stone_pressure_plate": "Камнєна наступна плита",
  "block.minecraft.stone_slab": "Камнєна плита",
  "block.minecraft.stone_stairs": "Камнєні сходи",
  "block.minecraft.stonecutter": "Різник камінє",
  "block.minecraft.stripped_acacia_log": "Вобтесана терностручова ковбицє",
  "block.minecraft.stripped_acacia_wood": "Вобтесане терностручове дерево",
  "block.minecraft.stripped_bamboo_block": "Вобтесаний бльок бамбуса",
  "block.minecraft.stripped_birch_log": "Вобтесана березова ковбицє",
  "block.minecraft.stripped_birch_wood": "Вобтесане березове дерево",
  "block.minecraft.stripped_cherry_log": "Вобтесана вишнева ковбицє",
  "block.minecraft.stripped_cherry_wood": "Вобтесане вишневе дерево",
  "block.minecraft.stripped_crimson_hyphae": "Вобтесаний багровий нїлїй",
  "block.minecraft.stripped_crimson_stem": "Вобтесане багрове дерево",
  "block.minecraft.stripped_dark_oak_log": "Вобтесана темнєкова ковбицє",
  "block.minecraft.stripped_dark_oak_wood": "Вобтесане темнєкове дерево",
  "block.minecraft.stripped_jungle_log": "Вобтесана джунґльова ковбицє",
  "block.minecraft.stripped_jungle_wood": "Вобтесане джунґльове дерево",
  "block.minecraft.stripped_mangrove_log": "Вобтесана манґровна ковбицє",
  "block.minecraft.stripped_mangrove_wood": "Вобтесане манґровне дерево",
  "block.minecraft.stripped_oak_log": "Вобтесана дубова ковбицє",
  "block.minecraft.stripped_oak_wood": "Вобтесане дубове дерево",
  "block.minecraft.stripped_pale_oak_log": "Вобтесана блїдєкова ковбицє",
  "block.minecraft.stripped_pale_oak_wood": "Вобтесане блїдєкове дерево",
  "block.minecraft.stripped_spruce_log": "Вобтесана смерекова ковбицє",
  "block.minecraft.stripped_spruce_wood": "Вобтесане смерекове дерево",
  "block.minecraft.stripped_warped_hyphae": "Вобтесаний покручений нїлїй",
  "block.minecraft.stripped_warped_stem": "Вобтесане покручене дерево",
  "block.minecraft.structure_block": "Бльок зложности",
  "block.minecraft.structure_void": "Порожнєва зложности",
  "block.minecraft.sugar_cane": "Цукрова трощє",
  "block.minecraft.sunflower": "Сонєшник",
  "block.minecraft.suspicious_gravel": "Підозріла рінь",
  "block.minecraft.suspicious_sand": "Підозрілий пісок",
  "block.minecraft.sweet_berry_bush": "Кущ з порічками",
  "block.minecraft.tall_dry_grass": "Висока суха трава",
  "block.minecraft.tall_grass": "Висока трава",
  "block.minecraft.tall_seagrass": "Висока морска трава",
  "block.minecraft.target": "Цїль",
  "block.minecraft.terracotta": "Печина",
  "block.minecraft.test_block": "Трібний бльок",
  "block.minecraft.test_instance_block": "Трібний примірниковий бльок",
  "block.minecraft.tinted_glass": "Тоноване шкло",
  "block.minecraft.tnt": "Динаміт",
  "block.minecraft.tnt.disabled": "Вибухи динаміта є вимкнені",
  "block.minecraft.torch": "Смолоскіп",
  "block.minecraft.torchflower": "Смолоцьвіт",
  "block.minecraft.torchflower_crop": "Врожєй смолоцьвітника",
  "block.minecraft.trapped_chest": "Куфер-пастка",
  "block.minecraft.trial_spawner": "Спавнер стрібунків",
  "block.minecraft.tripwire": "Розтєжка",
  "block.minecraft.tripwire_hook": "Гак до розтєжки",
  "block.minecraft.tube_coral": "Трубчєстий кораль",
  "block.minecraft.tube_coral_block": "Бльок трубчєстого коралє",
  "block.minecraft.tube_coral_fan": "Трубчєстий кораль-вахлєр",
  "block.minecraft.tube_coral_wall_fan": "Настїний трубчєстий кораль-вахлєр",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туфова цеглєна плита",
  "block.minecraft.tuff_brick_stairs": "Туфові цеглєні сходи",
  "block.minecraft.tuff_brick_wall": "Туфовий цеглєний мур",
  "block.minecraft.tuff_bricks": "Туфова цегла",
  "block.minecraft.tuff_slab": "Туфова плита",
  "block.minecraft.tuff_stairs": "Туфові сходи",
  "block.minecraft.tuff_wall": "Туфовий мур",
  "block.minecraft.turtle_egg": "Яйце черепахи",
  "block.minecraft.twisting_vines": "Кручені лози",
  "block.minecraft.twisting_vines_plant": "Бадилє крученої лози",
  "block.minecraft.vault": "Сховиско",
  "block.minecraft.verdant_froglight": "Дзелена жєблєча лямпа",
  "block.minecraft.vine": "Лози",
  "block.minecraft.void_air": "Пустоти повітрє",
  "block.minecraft.wall_torch": "Настїний смолоскіп",
  "block.minecraft.warped_button": "Покручена кнопка",
  "block.minecraft.warped_door": "Покручені двери",
  "block.minecraft.warped_fence": "Покручений пліт",
  "block.minecraft.warped_fence_gate": "Покручена фіртка",
  "block.minecraft.warped_fungus": "Покручена губа",
  "block.minecraft.warped_hanging_sign": "Покручена вивіска",
  "block.minecraft.warped_hyphae": "Покручений гіф",
  "block.minecraft.warped_nylium": "Покручений нїлїй",
  "block.minecraft.warped_planks": "Покручені дошки",
  "block.minecraft.warped_pressure_plate": "Покручена наступна плита",
  "block.minecraft.warped_roots": "Покручене корінє",
  "block.minecraft.warped_shelf": "Покручена полицє",
  "block.minecraft.warped_sign": "Покручений знак",
  "block.minecraft.warped_slab": "Покручена плита",
  "block.minecraft.warped_stairs": "Покручені сходи",
  "block.minecraft.warped_stem": "Покручене бадилє",
  "block.minecraft.warped_trapdoor": "Покручена ляда",
  "block.minecraft.warped_wall_hanging_sign": "Покручена стїна вивіска",
  "block.minecraft.warped_wall_sign": "Покручений стїний знак",
  "block.minecraft.warped_wart_block": "Бльок покручених пипок",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Саганок з водов",
  "block.minecraft.waxed_chiseled_copper": "Воскована різьблена мідь",
  "block.minecraft.waxed_copper_bars": "Восковані мідні ґрати",
  "block.minecraft.waxed_copper_block": "Бльок воскованої міди",
  "block.minecraft.waxed_copper_bulb": "Воскована мідна лямпа",
  "block.minecraft.waxed_copper_chain": "Воскований мідний ланц",
  "block.minecraft.waxed_copper_chest": "Воскований мідний куфер",
  "block.minecraft.waxed_copper_door": "Восковані мідні двери",
  "block.minecraft.waxed_copper_golem_statue": "Воскована статуя мідного ґолєма",
  "block.minecraft.waxed_copper_grate": "Воскована мідна решітка",
  "block.minecraft.waxed_copper_lantern": "Воскована мідна лямпа",
  "block.minecraft.waxed_copper_trapdoor": "Воскована мідна ляда",
  "block.minecraft.waxed_cut_copper": "Воскована виточена мідь",
  "block.minecraft.waxed_cut_copper_slab": "Воскована виточена мідна плита",
  "block.minecraft.waxed_cut_copper_stairs": "Восковані виточені мідні сходи",
  "block.minecraft.waxed_exposed_chiseled_copper": "Воскована потемнїла різьблена мідь",
  "block.minecraft.waxed_exposed_copper": "Воскована потемнїла мідь",
  "block.minecraft.waxed_exposed_copper_bars": "Восковані потемнїлі мідні ґрати",
  "block.minecraft.waxed_exposed_copper_bulb": "Воскована потемнїла мідна лямпа",
  "block.minecraft.waxed_exposed_copper_chain": "Воскований потемнїлий мідний ланц",
  "block.minecraft.waxed_exposed_copper_chest": "Воскована потемнїла статуя мідного куфра",
  "block.minecraft.waxed_exposed_copper_door": "Восковані потемнїлі мідні двери",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Воскована потемнїла статуя мідного ґолєма",
  "block.minecraft.waxed_exposed_copper_grate": "Воскована потемнїла мідна решітка",
  "block.minecraft.waxed_exposed_copper_lantern": "Воскована потемнїла мідна лямпа",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Воскована потемнїла мідна ляда",
  "block.minecraft.waxed_exposed_cut_copper": "Воскована потемнїла виточена мідь",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Воскована потемнїла виточена мідна плита",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Восковані потемнїлі виточені мідні сходи",
  "block.minecraft.waxed_exposed_lightning_rod": "Воскований потемнїлий громовід",
  "block.minecraft.waxed_lightning_rod": "Воскований громовід",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Воскована воксидована різьблена мідь",
  "block.minecraft.waxed_oxidized_copper": "Воскована воксидована мідь",
  "block.minecraft.waxed_oxidized_copper_bars": "Восковані воксидовані мідні ґрати",
  "block.minecraft.waxed_oxidized_copper_bulb": "Воскована воксидована мідна лямпа",
  "block.minecraft.waxed_oxidized_copper_chain": "Воскований воксидований мідний ланц",
  "block.minecraft.waxed_oxidized_copper_chest": "Воскований воксидований мідний куфер",
  "block.minecraft.waxed_oxidized_copper_door": "Восковані воксидовані мідні двери",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Воскована воксидована статуя мідного ґолєма",
  "block.minecraft.waxed_oxidized_copper_grate": "Воскована воксидована мідна решітка",
  "block.minecraft.waxed_oxidized_copper_lantern": "Воскована воксидована мідна лямпа",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Воскована воксидована мідна ляда",
  "block.minecraft.waxed_oxidized_cut_copper": "Воскована воксидована виточена мідь",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Воскована воксидована виточена мідна плита",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Восковані воксидовані виточені мідні сходи",
  "block.minecraft.waxed_oxidized_lightning_rod": "Воскований воксидований громовід",
  "block.minecraft.waxed_weathered_chiseled_copper": "Воскована зостаріла різьблена мідь",
  "block.minecraft.waxed_weathered_copper": "Воскована зостаріла мідь",
  "block.minecraft.waxed_weathered_copper_bars": "Восковані зостарілі мідні ґрати",
  "block.minecraft.waxed_weathered_copper_bulb": "Воскована зостаріла мідна лямпа",
  "block.minecraft.waxed_weathered_copper_chain": "Воскований зостарілий мідний ланц",
  "block.minecraft.waxed_weathered_copper_chest": "Воскований зостарілий мідний куфер",
  "block.minecraft.waxed_weathered_copper_door": "Восковані зостарілі мідні двери",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Воскована зостаріла статуя мідного ґолєма",
  "block.minecraft.waxed_weathered_copper_grate": "Воскована зостаріла мідна решітка",
  "block.minecraft.waxed_weathered_copper_lantern": "Воскована зостаріла мідна лямпа",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Воскована зостаріла мідна ляда",
  "block.minecraft.waxed_weathered_cut_copper": "Воскована зостаріла виточена мідь",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Воскована зостаріла виточена мідна плита",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Восковані зостарілі виточені мідні сходи",
  "block.minecraft.waxed_weathered_lightning_rod": "Воскований зостарілий громовід",
  "block.minecraft.weathered_chiseled_copper": "Зостаріла різьблена мідь",
  "block.minecraft.weathered_copper": "Зостаріла мідь",
  "block.minecraft.weathered_copper_bars": "Зостарілі мідні ґрати",
  "block.minecraft.weathered_copper_bulb": "Зостаріла мідна лямпа",
  "block.minecraft.weathered_copper_chain": "Зостарілий мідний ланц",
  "block.minecraft.weathered_copper_chest": "Зостарілий мідний куфер",
  "block.minecraft.weathered_copper_door": "Зостарілі мідні двери",
  "block.minecraft.weathered_copper_golem_statue": "Зостаріла статуя мідного ґолєма",
  "block.minecraft.weathered_copper_grate": "Зостаріла мідна решітка",
  "block.minecraft.weathered_copper_lantern": "Зостаріла мідна лямпа",
  "block.minecraft.weathered_copper_trapdoor": "Зостаріла мідна ляда",
  "block.minecraft.weathered_cut_copper": "Зостаріла виточена мідь",
  "block.minecraft.weathered_cut_copper_slab": "Зостаріла виточена мідна плита",
  "block.minecraft.weathered_cut_copper_stairs": "Зостарілі виточені мідні сходи",
  "block.minecraft.weathered_lightning_rod": "Зостарілий громовід",
  "block.minecraft.weeping_vines": "Плакучі лози",
  "block.minecraft.weeping_vines_plant": "Бадилє плакучих лоз",
  "block.minecraft.wet_sponge": "Мокра губка",
  "block.minecraft.wheat": "Врожай пшеницї",
  "block.minecraft.white_banner": "Біла фана",
  "block.minecraft.white_bed": "Біле ліжко",
  "block.minecraft.white_candle": "Біла сьвічка",
  "block.minecraft.white_candle_cake": "Пляцок з білов сьвічков",
  "block.minecraft.white_carpet": "Білий хідник",
  "block.minecraft.white_concrete": "Білий бетон",
  "block.minecraft.white_concrete_powder": "Білий цїмент",
  "block.minecraft.white_glazed_terracotta": "Біла поливєна печина",
  "block.minecraft.white_shulker_box": "Біле шулькер-пудевко",
  "block.minecraft.white_stained_glass": "Біле шкло",
  "block.minecraft.white_stained_glass_pane": "Біла шиба",
  "block.minecraft.white_terracotta": "Біла печина",
  "block.minecraft.white_tulip": "Білий тюльпан",
  "block.minecraft.white_wool": "Біла вовна",
  "block.minecraft.wildflowers": "Польовий цьвіт",
  "block.minecraft.wither_rose": "Ружа відера",
  "block.minecraft.wither_skeleton_skull": "Череп відера-шкілєта",
  "block.minecraft.wither_skeleton_wall_skull": "Настїний череп відера-шкілєта",
  "block.minecraft.yellow_banner": "Жовта фана",
  "block.minecraft.yellow_bed": "Жовте ліжко",
  "block.minecraft.yellow_candle": "Жовта сьвічка",
  "block.minecraft.yellow_candle_cake": "Пляцок зо жовтов сьвічков",
  "block.minecraft.yellow_carpet": "Жовтий хідник",
  "block.minecraft.yellow_concrete": "Жовтий бетон",
  "block.minecraft.yellow_concrete_powder": "Жовтий цїмент",
  "block.minecraft.yellow_glazed_terracotta": "Жовта поливєна печина",
  "block.minecraft.yellow_shulker_box": "Жовте шулькер-пудевко",
  "block.minecraft.yellow_stained_glass": "Жовте шкло",
  "block.minecraft.yellow_stained_glass_pane": "Жовта шиба",
  "block.minecraft.yellow_terracotta": "Жовта печина",
  "block.minecraft.yellow_wool": "Жовта вовна",
  "block.minecraft.zombie_head": "Голова мерцє",
  "block.minecraft.zombie_wall_head": "Настїна голова мерцє",
  "item.minecraft.acacia_boat": "Терностручовий човен",
  "item.minecraft.acacia_chest_boat": "Терностручовий човен з куфром",
  "item.minecraft.allay_spawn_egg": "Яйце появи марика",
  "item.minecraft.amethyst_shard": "Вометистовий кавалок",
  "item.minecraft.angler_pottery_shard": "Кавалок кераміки «Риболов»",
  "item.minecraft.angler_pottery_sherd": "Кавалок кераміки «Риболов»",
  "item.minecraft.apple": "Ябко",
  "item.minecraft.archer_pottery_shard": "Кавалок кераміки «Лучник»",
  "item.minecraft.archer_pottery_sherd": "Кавалок кераміки «Лучник»",
  "item.minecraft.armadillo_scute": "Дощинка панцерника",
  "item.minecraft.armadillo_spawn_egg": "Яйце появи панцерника",
  "item.minecraft.armor_stand": "Стійка до бронї",
  "item.minecraft.arms_up_pottery_shard": "Кавалок кераміки «Руки горі»",
  "item.minecraft.arms_up_pottery_sherd": "Кавалок кераміки «Руки горі»",
  "item.minecraft.arrow": "Стріла",
  "item.minecraft.axolotl_bucket": "Путнє з гаксольотльом",
  "item.minecraft.axolotl_spawn_egg": "Яйце появи гаксольотлє",
  "item.minecraft.baked_potato": "Запечена бараболє",
  "item.minecraft.bamboo_chest_raft": "Бамбусовий пліт з куфром",
  "item.minecraft.bamboo_raft": "Бамбусовий пліт",
  "item.minecraft.bat_spawn_egg": "Яйце появи лилика",
  "item.minecraft.bee_spawn_egg": "Яйце появи пчоли",
  "item.minecraft.beef": "Сьвіжина воловина",
  "item.minecraft.beetroot": "Бурак",
  "item.minecraft.beetroot_seeds": "Насїнє бурака",
  "item.minecraft.beetroot_soup": "Черлений борщ",
  "item.minecraft.birch_boat": "Березовий човен",
  "item.minecraft.birch_chest_boat": "Березовий човен з куфром",
  "item.minecraft.black_bundle": "Чорне міщє",
  "item.minecraft.black_dye": "Чорний барвник",
  "item.minecraft.black_harness": "Чорний хомут",
  "item.minecraft.blade_pottery_shard": "Кавалок кераміки «Клинка»",
  "item.minecraft.blade_pottery_sherd": "Кавалок кераміки «Клинка»",
  "item.minecraft.blaze_powder": "Поломіний порох",
  "item.minecraft.blaze_rod": "Поломіний прут",
  "item.minecraft.blaze_spawn_egg": "Яйце появи поломінє",
  "item.minecraft.blue_bundle": "Сине міщє",
  "item.minecraft.blue_dye": "Синий барвник",
  "item.minecraft.blue_egg": "Сине яйце",
  "item.minecraft.blue_harness": "Синий хомут",
  "item.minecraft.bogged_spawn_egg": "Яйце появи болотєника",
  "item.minecraft.bolt_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ворнамент бронї «Цьвєх»",
  "item.minecraft.bone": "Кість",
  "item.minecraft.bone_meal": "Кістна мука",
  "item.minecraft.book": "Книжка",
  "item.minecraft.bordure_indented_banner_pattern": "Візерунок фани «Зубчєта рамка»",
  "item.minecraft.bow": "Лук",
  "item.minecraft.bowl": "Миска",
  "item.minecraft.bread": "Хлїб",
  "item.minecraft.breeze_rod": "Вітровий прут",
  "item.minecraft.breeze_spawn_egg": "Яйце появи вітерцє",
  "item.minecraft.brewer_pottery_shard": "Кавалок кераміки «Пивовар»",
  "item.minecraft.brewer_pottery_sherd": "Кавалок кераміки «Пивовар»",
  "item.minecraft.brewing_stand": "Варильна стійка",
  "item.minecraft.brick": "Цегла",
  "item.minecraft.brown_bundle": "Брунатне міщє",
  "item.minecraft.brown_dye": "Брунатний барвник",
  "item.minecraft.brown_egg": "Брунатне яйце",
  "item.minecraft.brown_harness": "Брунатний хомут",
  "item.minecraft.brush": "Щітка",
  "item.minecraft.bucket": "Путнє",
  "item.minecraft.bundle": "Міщє",
  "item.minecraft.bundle.empty": "Пусто",
  "item.minecraft.bundle.empty.description": "Годно вміщєти пару ріжних предметів",
  "item.minecraft.bundle.full": "Повне",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Кавалок кераміки «Поломінь»",
  "item.minecraft.burn_pottery_sherd": "Кавалок кераміки «Поломінь»",
  "item.minecraft.camel_husk_spawn_egg": "Яйце появи верхоблюда-сушнє",
  "item.minecraft.camel_spawn_egg": "Яйце появи верхоблюда",
  "item.minecraft.carrot": "Морква",
  "item.minecraft.carrot_on_a_stick": "Морква на патику",
  "item.minecraft.cat_spawn_egg": "Яйце появи коцура",
  "item.minecraft.cauldron": "Саганок",
  "item.minecraft.cave_spider_spawn_egg": "Яйце появи печерного павука",
  "item.minecraft.chainmail_boots": "Ланцьовані боти",
  "item.minecraft.chainmail_chestplate": "Ланцьована кошулє",
  "item.minecraft.chainmail_helmet": "Ланцьований шолом",
  "item.minecraft.chainmail_leggings": "Ланцьовані ногавицї",
  "item.minecraft.charcoal": "Деревлєне вуглє",
  "item.minecraft.cherry_boat": "Вишневий човен",
  "item.minecraft.cherry_chest_boat": "Вишневий човен з куфром",
  "item.minecraft.chest_minecart": "Візок з куфром",
  "item.minecraft.chicken": "Сьвіжина курєтина",
  "item.minecraft.chicken_spawn_egg": "Яйце появи курки",
  "item.minecraft.chorus_fruit": "Садовина хоруса",
  "item.minecraft.clay_ball": "Кулька глини",
  "item.minecraft.clock": "Дзиґарок",
  "item.minecraft.coal": "Вуглє",
  "item.minecraft.coast_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ворнамент бронї «Беріг»",
  "item.minecraft.cocoa_beans": "Какавові боби",
  "item.minecraft.cod": "Сира тріска",
  "item.minecraft.cod_bucket": "Путнє з трісков",
  "item.minecraft.cod_spawn_egg": "Яйце появи тріски",
  "item.minecraft.command_block_minecart": "Візок з наказовим бльоком",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Зрихтована воловина",
  "item.minecraft.cooked_chicken": "Зрихтована курєтина",
  "item.minecraft.cooked_cod": "Зрихтована тріска",
  "item.minecraft.cooked_mutton": "Зрихтована баранина",
  "item.minecraft.cooked_porkchop": "Зрихтована свинина",
  "item.minecraft.cooked_rabbit": "Зрихтований кріль",
  "item.minecraft.cooked_salmon": "Зрихтований пструг",
  "item.minecraft.cookie": "Печенє",
  "item.minecraft.copper_axe": "Мідний топір",
  "item.minecraft.copper_boots": "Мідні боти",
  "item.minecraft.copper_chestplate": "Мідний кирас",
  "item.minecraft.copper_golem_spawn_egg": "Яйце появи мідного ґолєма",
  "item.minecraft.copper_helmet": "Мідний шолом",
  "item.minecraft.copper_hoe": "Мідна сапка",
  "item.minecraft.copper_horse_armor": "Мідна кіньска збруя",
  "item.minecraft.copper_ingot": "Мідний зливок",
  "item.minecraft.copper_leggings": "Мідні ногавицї",
  "item.minecraft.copper_nautilus_armor": "Мідна корабликова збруя",
  "item.minecraft.copper_nugget": "Мідний кавальчик",
  "item.minecraft.copper_pickaxe": "Мідний дзюбак",
  "item.minecraft.copper_shovel": "Мідний рискаль",
  "item.minecraft.copper_spear": "Мідне копє",
  "item.minecraft.copper_sword": "Мідний меч",
  "item.minecraft.cow_spawn_egg": "Яйце появи корови",
  "item.minecraft.creaking_spawn_egg": "Яйце появи тріскачє",
  "item.minecraft.creeper_banner_pattern": "Візерунок фани",
  "item.minecraft.creeper_banner_pattern.desc": "Твар крипера",
  "item.minecraft.creeper_banner_pattern.new": "Візерунок фани «Твар крипера»",
  "item.minecraft.creeper_spawn_egg": "Яйце появи крипера",
  "item.minecraft.crossbow": "Самостріл",
  "item.minecraft.crossbow.projectile": "Набір:",
  "item.minecraft.crossbow.projectile.multiple": "Набір: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Набір: %s",
  "item.minecraft.cyan_bundle": "Циянове міщє",
  "item.minecraft.cyan_dye": "Морский барвник",
  "item.minecraft.cyan_harness": "Морский хомут",
  "item.minecraft.danger_pottery_shard": "Кавалок кераміки «Небезпека»",
  "item.minecraft.danger_pottery_sherd": "Кавалок кераміки «Небезпека»",
  "item.minecraft.dark_oak_boat": "Темнєковий човен",
  "item.minecraft.dark_oak_chest_boat": "Темнєковий човен з куфром",
  "item.minecraft.debug_stick": "Патик доладженє",
  "item.minecraft.debug_stick.empty": "%s не має якостий",
  "item.minecraft.debug_stick.select": "вибрано \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" до %s",
  "item.minecraft.diamond": "Диямант",
  "item.minecraft.diamond_axe": "Диямантовий топір",
  "item.minecraft.diamond_boots": "Диямантові боти",
  "item.minecraft.diamond_chestplate": "Диямантовий кирас",
  "item.minecraft.diamond_helmet": "Диямантовий шолом",
  "item.minecraft.diamond_hoe": "Диямантова сапка",
  "item.minecraft.diamond_horse_armor": "Диямантова кіньска збруя",
  "item.minecraft.diamond_leggings": "Диямантові ногавицї",
  "item.minecraft.diamond_nautilus_armor": "Диямантова корабликова збруя",
  "item.minecraft.diamond_pickaxe": "Диямантовий дзюбак",
  "item.minecraft.diamond_shovel": "Диямантовий рискаль",
  "item.minecraft.diamond_spear": "Диямантове копє",
  "item.minecraft.diamond_sword": "Диямантовий меч",
  "item.minecraft.disc_fragment_5": "Кавалок пластинки",
  "item.minecraft.disc_fragment_5.desc": "Ґрамофона пластинка — 5",
  "item.minecraft.dolphin_spawn_egg": "Яйце появи дельфіна",
  "item.minecraft.donkey_spawn_egg": "Яйце появи восла",
  "item.minecraft.dragon_breath": "Диханє зьмія",
  "item.minecraft.dried_kelp": "Сушена лямінария",
  "item.minecraft.drowned_spawn_egg": "Яйце появи втопленика",
  "item.minecraft.dune_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ворнамент бронї «Дюна»",
  "item.minecraft.echo_shard": "Кавалок відлунє",
  "item.minecraft.egg": "Яйце",
  "item.minecraft.elder_guardian_spawn_egg": "Яйце появи старцє-сторожє",
  "item.minecraft.elytra": "Єлїтри",
  "item.minecraft.emerald": "Шмараґд",
  "item.minecraft.enchanted_book": "Примовлена книжка",
  "item.minecraft.enchanted_golden_apple": "Примовлене золоте ябко",
  "item.minecraft.end_crystal": "Криштал Єнда",
  "item.minecraft.ender_dragon_spawn_egg": "Яйце появи Єндер зьмія",
  "item.minecraft.ender_eye": "Воко Єндера",
  "item.minecraft.ender_pearl": "Єндер перла",
  "item.minecraft.enderman_spawn_egg": "Яйце появи єндермана",
  "item.minecraft.endermite_spawn_egg": "Яйце появи єндермайта",
  "item.minecraft.evoker_spawn_egg": "Яйце появи мольфара",
  "item.minecraft.experience_bottle": "Флєщина зо знатєм",
  "item.minecraft.explorer_pottery_shard": "Кавалок кераміки «Вивідец»",
  "item.minecraft.explorer_pottery_sherd": "Кавалок кераміки «Вивідец»",
  "item.minecraft.eye_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ворнамент бронї «Воко»",
  "item.minecraft.feather": "Пірє",
  "item.minecraft.fermented_spider_eye": "Заквашене воко павука",
  "item.minecraft.field_masoned_banner_pattern": "Візерунок фани «Цеглєне тло»",
  "item.minecraft.filled_map": "Мапа",
  "item.minecraft.fire_charge": "Вогнєвий набій",
  "item.minecraft.firework_rocket": "Феєрверк",
  "item.minecraft.firework_rocket.flight": "Тривалість польоту:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Зьвізда феєрверка",
  "item.minecraft.firework_star.black": "Чорна",
  "item.minecraft.firework_star.blue": "Сина",
  "item.minecraft.firework_star.brown": "Брунатна",
  "item.minecraft.firework_star.custom_color": "Власна",
  "item.minecraft.firework_star.cyan": "Морска",
  "item.minecraft.firework_star.fade_to": "Гасне в",
  "item.minecraft.firework_star.flicker": "Блискає",
  "item.minecraft.firework_star.gray": "Сїра",
  "item.minecraft.firework_star.green": "Дзелена",
  "item.minecraft.firework_star.light_blue": "Голуба",
  "item.minecraft.firework_star.light_gray": "Крицева",
  "item.minecraft.firework_star.lime": "Салатова",
  "item.minecraft.firework_star.magenta": "Фукзиєва",
  "item.minecraft.firework_star.orange": "Цеглова",
  "item.minecraft.firework_star.pink": "Ружова",
  "item.minecraft.firework_star.purple": "Фійолєтова",
  "item.minecraft.firework_star.red": "Черлена",
  "item.minecraft.firework_star.shape": "Незнана форма",
  "item.minecraft.firework_star.shape.burst": "Буханє",
  "item.minecraft.firework_star.shape.creeper": "Крипероподібний",
  "item.minecraft.firework_star.shape.large_ball": "Великий бальон",
  "item.minecraft.firework_star.shape.small_ball": "Мацьонкий бальон",
  "item.minecraft.firework_star.shape.star": "Зьвіздоподібний",
  "item.minecraft.firework_star.trail": "Слїди",
  "item.minecraft.firework_star.white": "Біла",
  "item.minecraft.firework_star.yellow": "Жовта",
  "item.minecraft.fishing_rod": "Вудка",
  "item.minecraft.flint": "Кремінь",
  "item.minecraft.flint_and_steel": "Дзиґарничка",
  "item.minecraft.flow_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ворнамент бронї «Потік»",
  "item.minecraft.flow_banner_pattern": "Візерунок фани",
  "item.minecraft.flow_banner_pattern.desc": "Потік",
  "item.minecraft.flow_banner_pattern.new": "Візерунок фани «Потік»",
  "item.minecraft.flow_pottery_sherd": "Кавалок кераміки «Потік»",
  "item.minecraft.flower_banner_pattern": "Візерунок фани",
  "item.minecraft.flower_banner_pattern.desc": "Відбиток цьвітки",
  "item.minecraft.flower_banner_pattern.new": "Візерунок фани «Відбиток цьвітки»",
  "item.minecraft.flower_pot": "Вазонок",
  "item.minecraft.fox_spawn_egg": "Яйце появи лисицї",
  "item.minecraft.friend_pottery_shard": "Кавалок кераміки «Колєґа»",
  "item.minecraft.friend_pottery_sherd": "Кавалок кераміки «Колєґа»",
  "item.minecraft.frog_spawn_egg": "Яйце появи жєби",
  "item.minecraft.furnace_minecart": "Візок з пєцом",
  "item.minecraft.ghast_spawn_egg": "Яйце появи ґаста",
  "item.minecraft.ghast_tear": "Слиза ґаста",
  "item.minecraft.glass_bottle": "Флєшка",
  "item.minecraft.glistering_melon_slice": "Лискуча байда кавуна",
  "item.minecraft.globe_banner_pattern": "Візерунок фани",
  "item.minecraft.globe_banner_pattern.desc": "Ґльобус",
  "item.minecraft.globe_banner_pattern.new": "Візерунок фани «Ґльобус»",
  "item.minecraft.glow_berries": "Сєйні ягоди",
  "item.minecraft.glow_ink_sac": "Сєйне чорнильне міщє",
  "item.minecraft.glow_item_frame": "Сєйна рамка на предмет",
  "item.minecraft.glow_squid_spawn_egg": "Яйце появи сєйного мутнєка",
  "item.minecraft.glowstone_dust": "Порох сьвітлокамінє",
  "item.minecraft.goat_horn": "Ріг цапа",
  "item.minecraft.goat_spawn_egg": "Яйце появи цапа",
  "item.minecraft.gold_ingot": "Золотий зливок",
  "item.minecraft.gold_nugget": "Золотий кавальчик",
  "item.minecraft.golden_apple": "Золоте ябко",
  "item.minecraft.golden_axe": "Золотий топір",
  "item.minecraft.golden_boots": "Золоті боти",
  "item.minecraft.golden_carrot": "Золота морква",
  "item.minecraft.golden_chestplate": "Золотий кирас",
  "item.minecraft.golden_helmet": "Золотий шолом",
  "item.minecraft.golden_hoe": "Золота сапка",
  "item.minecraft.golden_horse_armor": "Золота кіньска збруя",
  "item.minecraft.golden_leggings": "Золоті ногавицї",
  "item.minecraft.golden_nautilus_armor": "Золота корабликова збруя",
  "item.minecraft.golden_pickaxe": "Золотий дзюбак",
  "item.minecraft.golden_shovel": "Золотий рискаль",
  "item.minecraft.golden_spear": "Золоте копє",
  "item.minecraft.golden_sword": "Золотий меч",
  "item.minecraft.gray_bundle": "Сїре міщє",
  "item.minecraft.gray_dye": "Сїрий барвник",
  "item.minecraft.gray_harness": "Сїрий хомут",
  "item.minecraft.green_bundle": "Дзелене міщє",
  "item.minecraft.green_dye": "Дзелений барвник",
  "item.minecraft.green_harness": "Дзелений хомут",
  "item.minecraft.guardian_spawn_egg": "Яйце появи сторожє",
  "item.minecraft.gunpowder": "Стрільний порох",
  "item.minecraft.guster_banner_pattern": "Візерунок фани",
  "item.minecraft.guster_banner_pattern.desc": "Вітерец",
  "item.minecraft.guster_banner_pattern.new": "Візерунок фани «Ветерец»",
  "item.minecraft.guster_pottery_sherd": "Кавалок кераміки «Вітерец»",
  "item.minecraft.happy_ghast_spawn_egg": "Яйце появи щєстливого ґаста",
  "item.minecraft.harness": "Хомут",
  "item.minecraft.heart_of_the_sea": "Серце морє",
  "item.minecraft.heart_pottery_shard": "Кавалок кераміки «Серце»",
  "item.minecraft.heart_pottery_sherd": "Кавалок кераміки «Серце»",
  "item.minecraft.heartbreak_pottery_shard": "Кавалок кераміки «Роздерте серце»",
  "item.minecraft.heartbreak_pottery_sherd": "Кавалок кераміки «Роздерте серце»",
  "item.minecraft.hoglin_spawn_egg": "Яйце появи гоґлїна",
  "item.minecraft.honey_bottle": "Флєщина меда",
  "item.minecraft.honeycomb": "Медові стільники",
  "item.minecraft.hopper_minecart": "Візок з лїйков",
  "item.minecraft.horse_spawn_egg": "Яйце появи конє",
  "item.minecraft.host_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ворнамент бронї «Ґазда»",
  "item.minecraft.howl_pottery_shard": "Кавалок кераміки «Рев»",
  "item.minecraft.howl_pottery_sherd": "Кавалок кераміки «Рев»",
  "item.minecraft.husk_spawn_egg": "Яйце появи сушнє",
  "item.minecraft.ink_sac": "Чорнильне міщє",
  "item.minecraft.iron_axe": "Дзелїзний топір",
  "item.minecraft.iron_boots": "Дзелїзні боти",
  "item.minecraft.iron_chestplate": "Дзелїзний кирас",
  "item.minecraft.iron_golem_spawn_egg": "Яйце появи дзелїзного ґолєма",
  "item.minecraft.iron_helmet": "Дзелїзний шолом",
  "item.minecraft.iron_hoe": "Дзелїзна сапка",
  "item.minecraft.iron_horse_armor": "Дзелїзна кіньска збруя",
  "item.minecraft.iron_ingot": "Дзелїзний зливок",
  "item.minecraft.iron_leggings": "Дзелїзні ногавицї",
  "item.minecraft.iron_nautilus_armor": "Дзелїзна корабликова збруя",
  "item.minecraft.iron_nugget": "Дзелїзний кавальчик",
  "item.minecraft.iron_pickaxe": "Дзелїзний дзюбак",
  "item.minecraft.iron_shovel": "Дзелїзний рискаль",
  "item.minecraft.iron_spear": "Дзелїзне копє",
  "item.minecraft.iron_sword": "Дзелїзний меч",
  "item.minecraft.item_frame": "Рамка на предмет",
  "item.minecraft.jungle_boat": "Джунґльовий човен",
  "item.minecraft.jungle_chest_boat": "Джунґльовий човен з куфром",
  "item.minecraft.knowledge_book": "Книжка знань",
  "item.minecraft.lapis_lazuli": "Лязурит",
  "item.minecraft.lava_bucket": "Путнє ляви",
  "item.minecraft.lead": "Повідец",
  "item.minecraft.leather": "Шкіра",
  "item.minecraft.leather_boots": "Шкірєні боти",
  "item.minecraft.leather_chestplate": "Шкірєнка",
  "item.minecraft.leather_helmet": "Шкірєна шєпка",
  "item.minecraft.leather_horse_armor": "Шкірєна кіньска збруя",
  "item.minecraft.leather_leggings": "Шкірєні споднї",
  "item.minecraft.light_blue_bundle": "Голубе міщє",
  "item.minecraft.light_blue_dye": "Голубий барвник",
  "item.minecraft.light_blue_harness": "Голубий хомут",
  "item.minecraft.light_gray_bundle": "Крицеве міщє",
  "item.minecraft.light_gray_dye": "Крицевий барвник",
  "item.minecraft.light_gray_harness": "Крицевий хомут",
  "item.minecraft.lime_bundle": "Салатове міщє",
  "item.minecraft.lime_dye": "Салатовий барвник",
  "item.minecraft.lime_harness": "Салатовий хомут",
  "item.minecraft.lingering_potion": "Туманий зварок",
  "item.minecraft.lingering_potion.effect.awkward": "Дивний туманий зварок",
  "item.minecraft.lingering_potion.effect.empty": "Туманий несотворьовальний зварок",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Туманий зварок вогньовідпори",
  "item.minecraft.lingering_potion.effect.harming": "Туманий зварок кривди",
  "item.minecraft.lingering_potion.effect.healing": "Туманий зварок зцїленє",
  "item.minecraft.lingering_potion.effect.infested": "Туманий зварок зараженє",
  "item.minecraft.lingering_potion.effect.invisibility": "Туманий зварок невидимости",
  "item.minecraft.lingering_potion.effect.leaping": "Туманий зварок скакучости",
  "item.minecraft.lingering_potion.effect.levitation": "Туманий зварок лєвітациї",
  "item.minecraft.lingering_potion.effect.luck": "Туманий зварок везїнє",
  "item.minecraft.lingering_potion.effect.mundane": "Звичєйний туманий зварок",
  "item.minecraft.lingering_potion.effect.night_vision": "Туманий зварок нічного зора",
  "item.minecraft.lingering_potion.effect.oozing": "Туманий зварок слїзистоти",
  "item.minecraft.lingering_potion.effect.poison": "Туманий зварок втроєнє",
  "item.minecraft.lingering_potion.effect.regeneration": "Туманий зварок відновленє",
  "item.minecraft.lingering_potion.effect.slow_falling": "Туманий зварок поволого паданє",
  "item.minecraft.lingering_potion.effect.slowness": "Туманий зварок поволости",
  "item.minecraft.lingering_potion.effect.strength": "Туманий зварок сили",
  "item.minecraft.lingering_potion.effect.swiftness": "Туманий зварок борзости",
  "item.minecraft.lingering_potion.effect.thick": "Густий туманий зварок",
  "item.minecraft.lingering_potion.effect.turtle_master": "Туманий зварок черепашєчої мочи",
  "item.minecraft.lingering_potion.effect.water": "Тумана флєщина з водов",
  "item.minecraft.lingering_potion.effect.water_breathing": "Туманий зварок водного диханє",
  "item.minecraft.lingering_potion.effect.weakness": "Туманий зварок слабости",
  "item.minecraft.lingering_potion.effect.weaving": "Туманий зварок плетенє",
  "item.minecraft.lingering_potion.effect.wind_charged": "Туманий зварок вітрєности",
  "item.minecraft.llama_spawn_egg": "Яйце появи лями",
  "item.minecraft.lodestone_compass": "Намаґнечений компас",
  "item.minecraft.mace": "Вобух",
  "item.minecraft.magenta_bundle": "Фукзиєве міщє",
  "item.minecraft.magenta_dye": "Фукзиєвий барвник",
  "item.minecraft.magenta_harness": "Фукзиєвий хомут",
  "item.minecraft.magma_cream": "Маґмовий крем",
  "item.minecraft.magma_cube_spawn_egg": "Яйце появи маґма куба",
  "item.minecraft.mangrove_boat": "Манґровний човен",
  "item.minecraft.mangrove_chest_boat": "Манґровний човен з куфром",
  "item.minecraft.map": "Пуста мапа ",
  "item.minecraft.melon_seeds": "Насїнє кавуна",
  "item.minecraft.melon_slice": "Байда кавуна",
  "item.minecraft.milk_bucket": "Путнє молока",
  "item.minecraft.minecart": "Візок",
  "item.minecraft.miner_pottery_shard": "Кавалок кераміки «Гірнєк»",
  "item.minecraft.miner_pottery_sherd": "Кавалок кераміки «Гірнєк»",
  "item.minecraft.mojang_banner_pattern": "Візерунок фани",
  "item.minecraft.mojang_banner_pattern.desc": "Річ",
  "item.minecraft.mojang_banner_pattern.new": "Візерунок фани «Річ»",
  "item.minecraft.mooshroom_spawn_egg": "Яйце появи мушрума",
  "item.minecraft.mourner_pottery_shard": "Кавалок кераміки «Жєлобник»",
  "item.minecraft.mourner_pottery_sherd": "Кавалок кераміки «Жєлобник»",
  "item.minecraft.mule_spawn_egg": "Яйце появи мулє",
  "item.minecraft.mushroom_stew": "Тушені губи",
  "item.minecraft.music_disc_11": "Ґрамофона пластинка",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Ґрамофона пластинка",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Ґрамофона пластинка",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Ґрамофона пластинка",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Ґрамофона пластинка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Ґрамофона пластинка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Ґрамофона пластинка",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Ґрамофона пластинка",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Ґрамофона пластинка",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Ґрамофона пластинка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Ґрамофона пластинка",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Ґрамофона пластинка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Ґрамофона пластинка",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Ґрамофона пластинка",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Ґрамофона пластинка",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Ґрамофона пластинка",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Ґрамофона пластинка",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Ґрамофона пластинка",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Ґрамофона пластинка",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Ґрамофона пластинка",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Ґрамофона пластинка",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Сьвіжина баранина",
  "item.minecraft.name_tag": "Бірка",
  "item.minecraft.nautilus_shell": "Раковина кораблика",
  "item.minecraft.nautilus_spawn_egg": "Яйце появи кораблика",
  "item.minecraft.nether_brick": "Недерска цегла",
  "item.minecraft.nether_star": "Недерска зьвізда",
  "item.minecraft.nether_wart": "Недерскі пипки",
  "item.minecraft.netherite_axe": "Недеритовий топір",
  "item.minecraft.netherite_boots": "Недеритові боти",
  "item.minecraft.netherite_chestplate": "Недеритовий кирас",
  "item.minecraft.netherite_helmet": "Недеритовий шолом",
  "item.minecraft.netherite_hoe": "Недерска сапка",
  "item.minecraft.netherite_horse_armor": "Недеритова кіньска збруя",
  "item.minecraft.netherite_ingot": "Недеритовий зливок",
  "item.minecraft.netherite_leggings": "Недеритові ногавицї",
  "item.minecraft.netherite_nautilus_armor": "Недеритова корабликова збруя",
  "item.minecraft.netherite_pickaxe": "Недеритовий дзюбак",
  "item.minecraft.netherite_scrap": "Недеритовий кавальчик",
  "item.minecraft.netherite_shovel": "Недеритовий рискаль",
  "item.minecraft.netherite_spear": "Недеритове копє",
  "item.minecraft.netherite_sword": "Недеритовий меч",
  "item.minecraft.netherite_upgrade_smithing_template": "Ковальский шєбльон",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Недеритове полїпшенє",
  "item.minecraft.oak_boat": "Дубовий човен",
  "item.minecraft.oak_chest_boat": "Дубовий човен з куфром",
  "item.minecraft.ocelot_spawn_egg": "Яйце появи восельотлє",
  "item.minecraft.ominous_bottle": "Зла флєщина",
  "item.minecraft.ominous_trial_key": "Злий ключ стрібувань",
  "item.minecraft.orange_bundle": "Цеглове міщє",
  "item.minecraft.orange_dye": "Цегловий барвник",
  "item.minecraft.orange_harness": "Цегловий хомут",
  "item.minecraft.painting": "Картина",
  "item.minecraft.pale_oak_boat": "Блїдєковий човен",
  "item.minecraft.pale_oak_chest_boat": "Блїдєковий човен з куфром",
  "item.minecraft.panda_spawn_egg": "Яйце появи панди",
  "item.minecraft.paper": "Папер",
  "item.minecraft.parched_spawn_egg": "Яйце появи пустиника",
  "item.minecraft.parrot_spawn_egg": "Яйце появи папуґи",
  "item.minecraft.phantom_membrane": "Фантомова мембрана",
  "item.minecraft.phantom_spawn_egg": "Яйце появи фантома",
  "item.minecraft.pig_spawn_egg": "Яйце появи свинї",
  "item.minecraft.piglin_banner_pattern": "Візерунок фани",
  "item.minecraft.piglin_banner_pattern.desc": "Рийка",
  "item.minecraft.piglin_banner_pattern.new": "Візерунок фани «Рийка»",
  "item.minecraft.piglin_brute_spawn_egg": "Яйце появи піґлїна мурґи",
  "item.minecraft.piglin_spawn_egg": "Яйце появи піґлїна",
  "item.minecraft.pillager_spawn_egg": "Яйце появи батєра",
  "item.minecraft.pink_bundle": "Ружове міщє",
  "item.minecraft.pink_dye": "Ружовий барвник",
  "item.minecraft.pink_harness": "Ружовий хомут",
  "item.minecraft.pitcher_plant": "Дзбанок",
  "item.minecraft.pitcher_pod": "Старолїтне насінє",
  "item.minecraft.plenty_pottery_shard": "Кавалок кераміки «Достаток»",
  "item.minecraft.plenty_pottery_sherd": "Кавалок кераміки «Достаток»",
  "item.minecraft.poisonous_potato": "Дзелена бараболє",
  "item.minecraft.polar_bear_spawn_egg": "Яйце появи полярного медведє",
  "item.minecraft.popped_chorus_fruit": "Спечена садовина хоруса",
  "item.minecraft.porkchop": "Сьвіжина свинина",
  "item.minecraft.potato": "Бараболє",
  "item.minecraft.potion": "Зварок",
  "item.minecraft.potion.effect.awkward": "Дивний зварок",
  "item.minecraft.potion.effect.empty": "Несотворювальний зварок",
  "item.minecraft.potion.effect.fire_resistance": "Зварок вогньовідпори",
  "item.minecraft.potion.effect.harming": "Зварок кривди",
  "item.minecraft.potion.effect.healing": "Зварок зцїленє",
  "item.minecraft.potion.effect.infested": "Зварок зараженє",
  "item.minecraft.potion.effect.invisibility": "Зварок невидимости",
  "item.minecraft.potion.effect.leaping": "Зварок скакучости",
  "item.minecraft.potion.effect.levitation": "Зварок лєвітациї",
  "item.minecraft.potion.effect.luck": "Зварок везїнє",
  "item.minecraft.potion.effect.mundane": "Звичєйний зварок",
  "item.minecraft.potion.effect.night_vision": "Зварок нічного зору",
  "item.minecraft.potion.effect.oozing": "Зварок слїзистости",
  "item.minecraft.potion.effect.poison": "Зварок втроєнє",
  "item.minecraft.potion.effect.regeneration": "Зварок відновленє",
  "item.minecraft.potion.effect.slow_falling": "Зварок поволого паданє",
  "item.minecraft.potion.effect.slowness": "Зварок поволости",
  "item.minecraft.potion.effect.strength": "Зварок сили",
  "item.minecraft.potion.effect.swiftness": "Зварок борзости",
  "item.minecraft.potion.effect.thick": "Густий зварок",
  "item.minecraft.potion.effect.turtle_master": "Зварок черепашєчої мочи",
  "item.minecraft.potion.effect.water": "Флєщина з водов",
  "item.minecraft.potion.effect.water_breathing": "Зварок водного диханє",
  "item.minecraft.potion.effect.weakness": "Зварок слабости",
  "item.minecraft.potion.effect.weaving": "Зварок плетенє",
  "item.minecraft.potion.effect.wind_charged": "Зварок вітрєности",
  "item.minecraft.pottery_shard_archer": "Кавалок кераміки «Лучник»",
  "item.minecraft.pottery_shard_arms_up": "Кавалок кераміки «Руки горі»",
  "item.minecraft.pottery_shard_prize": "Кавалок кераміки «Надгорода»",
  "item.minecraft.pottery_shard_skull": "Кавалок кераміки «Череп»",
  "item.minecraft.powder_snow_bucket": "Відро пухкого снїга",
  "item.minecraft.prismarine_crystals": "Призмаринові кришталі",
  "item.minecraft.prismarine_shard": "Кавалок призмарина",
  "item.minecraft.prize_pottery_shard": "Кавалок кераміки «Надгорода»",
  "item.minecraft.prize_pottery_sherd": "Кавалок кераміки «Надгорода»",
  "item.minecraft.pufferfish": "Кулериба",
  "item.minecraft.pufferfish_bucket": "Путнє з кулерибов",
  "item.minecraft.pufferfish_spawn_egg": "Яйце появи кулериби",
  "item.minecraft.pumpkin_pie": "Гарбузовий пиріг",
  "item.minecraft.pumpkin_seeds": "Насїнє гарбуза",
  "item.minecraft.purple_bundle": "Фійолєтове міщє",
  "item.minecraft.purple_dye": "Фійолєтовий барвник",
  "item.minecraft.purple_harness": "Фійолєтовий хомут",
  "item.minecraft.quartz": "Недерский кварц",
  "item.minecraft.rabbit": "Сьвіжина кролє",
  "item.minecraft.rabbit_foot": "Крілєча лабка",
  "item.minecraft.rabbit_hide": "Крілєча шкірка",
  "item.minecraft.rabbit_spawn_egg": "Яйце появи кролє",
  "item.minecraft.rabbit_stew": "Тушений кріль",
  "item.minecraft.raiser_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ворнамент бронї «Білих хорватів»",
  "item.minecraft.ravager_spawn_egg": "Яйце появи бицайла",
  "item.minecraft.raw_copper": "Сира мідь",
  "item.minecraft.raw_gold": "Сире золото",
  "item.minecraft.raw_iron": "Сире дзелїзо",
  "item.minecraft.recovery_compass": "Компас вертанє",
  "item.minecraft.red_bundle": "Черлене міщє",
  "item.minecraft.red_dye": "Черлений барвник",
  "item.minecraft.red_harness": "Черлений хомут",
  "item.minecraft.redstone": "Редстовновий порох",
  "item.minecraft.resin_brick": "Смолєна цегла",
  "item.minecraft.resin_clump": "Кавальчик смоли",
  "item.minecraft.rib_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ворнамент бронї «Крижі»",
  "item.minecraft.rotten_flesh": "Гниле мнєсо",
  "item.minecraft.saddle": "Сїдло",
  "item.minecraft.salmon": "Сирий пструг",
  "item.minecraft.salmon_bucket": "Путнє з пстругом",
  "item.minecraft.salmon_spawn_egg": "Яйце появи пструга",
  "item.minecraft.scrape_pottery_sherd": "Кавалок кераміки «Шкробанє»",
  "item.minecraft.scute": "Дощинка",
  "item.minecraft.sentry_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ворнамент бронї «Варта»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ворнамент бронї «Чорних хорватів»",
  "item.minecraft.sheaf_pottery_shard": "Кавалок кераміки «Барвєр»",
  "item.minecraft.sheaf_pottery_sherd": "Кавалок кераміки «Барвєр»",
  "item.minecraft.shears": "Ножицї",
  "item.minecraft.sheep_spawn_egg": "Яйце появи вівцї",
  "item.minecraft.shelter_pottery_shard": "Кавалок кераміки «Вукритє»",
  "item.minecraft.shelter_pottery_sherd": "Кавалок кераміки «Вукритє»",
  "item.minecraft.shield": "Щит",
  "item.minecraft.shield.black": "Чорний щит",
  "item.minecraft.shield.blue": "Синий щит",
  "item.minecraft.shield.brown": "Брунатний щит",
  "item.minecraft.shield.cyan": "Морский щит",
  "item.minecraft.shield.gray": "Сїрий щит",
  "item.minecraft.shield.green": "Дзелений щит",
  "item.minecraft.shield.light_blue": "Голубий щит",
  "item.minecraft.shield.light_gray": "Крицевий щит",
  "item.minecraft.shield.lime": "Салатовий щит",
  "item.minecraft.shield.magenta": "Фукзиєвий щит",
  "item.minecraft.shield.orange": "Цегловий щит",
  "item.minecraft.shield.pink": "Ружовий щит",
  "item.minecraft.shield.purple": "Фійолєтовий щит",
  "item.minecraft.shield.red": "Черлений щит",
  "item.minecraft.shield.white": "Білий щит",
  "item.minecraft.shield.yellow": "Жовтий щит",
  "item.minecraft.shulker_shell": "Шулькерова шкарлупа",
  "item.minecraft.shulker_spawn_egg": "Яйце появи шулькера",
  "item.minecraft.sign": "Знак",
  "item.minecraft.silence_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ворнамент бронї «Мовчєнє»",
  "item.minecraft.silverfish_spawn_egg": "Яйце появи лусківницї",
  "item.minecraft.skeleton_horse_spawn_egg": "Яйце появи конє-шкілєта",
  "item.minecraft.skeleton_spawn_egg": "Яйце появи шкілєта",
  "item.minecraft.skull_banner_pattern": "Візерунок фани",
  "item.minecraft.skull_banner_pattern.desc": "Відбиток черепа",
  "item.minecraft.skull_banner_pattern.new": "Візерунок фани «Відбиток черепа»",
  "item.minecraft.skull_pottery_shard": "Кавалок кераміки «Череп»",
  "item.minecraft.skull_pottery_sherd": "Кавалок кераміки «Череп»",
  "item.minecraft.slime_ball": "Слїзова кулє",
  "item.minecraft.slime_spawn_egg": "Яйце появи слїзенє",
  "item.minecraft.smithing_template": "Ковальский шєбльон",
  "item.minecraft.smithing_template.applies_to": "Примінєє сє до:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Додайте зливок альбо криштал",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Бронє",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Додайте чєстинку бронї",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Зливки а кришталі",
  "item.minecraft.smithing_template.ingredients": "Зложники:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Додайте недеритовий зливок",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Диямантове знадобленє",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Додайте диямантову броню, воружє ци знарєдє",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Недеритовий зливок",
  "item.minecraft.smithing_template.upgrade": "Полїпшенє: ",
  "item.minecraft.sniffer_spawn_egg": "Яйце появи нюхлиска",
  "item.minecraft.snort_pottery_shard": "Кавалок кераміки «Форкач»",
  "item.minecraft.snort_pottery_sherd": "Кавалок кераміки «Форкач»",
  "item.minecraft.snout_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ворнамент бронї «Твар»",
  "item.minecraft.snow_golem_spawn_egg": "Яйце появи снїжного ґолєма",
  "item.minecraft.snowball": "Снїжок",
  "item.minecraft.spectral_arrow": "Спектральна стріла",
  "item.minecraft.spider_eye": "Воко павука",
  "item.minecraft.spider_spawn_egg": "Яйце появи павука",
  "item.minecraft.spire_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ворнамент бронї «Вежа»",
  "item.minecraft.splash_potion": "Метальний зварок",
  "item.minecraft.splash_potion.effect.awkward": "Дивний метальне зварок",
  "item.minecraft.splash_potion.effect.empty": "Метальний несотрорьовальний зварок",
  "item.minecraft.splash_potion.effect.fire_resistance": "Метальний зварок вогньовідпори",
  "item.minecraft.splash_potion.effect.harming": "Метальний зварок кривди",
  "item.minecraft.splash_potion.effect.healing": "Метальний зварок зцїленє",
  "item.minecraft.splash_potion.effect.infested": "Метальний зварок зараженє",
  "item.minecraft.splash_potion.effect.invisibility": "Метальний зварок невидимости",
  "item.minecraft.splash_potion.effect.leaping": "Метальний зварок скакучости",
  "item.minecraft.splash_potion.effect.levitation": "Метальний зварок лєвітациї",
  "item.minecraft.splash_potion.effect.luck": "Метальний зварок везїнє",
  "item.minecraft.splash_potion.effect.mundane": "Звичєйний метальний зварок",
  "item.minecraft.splash_potion.effect.night_vision": "Метальний зварок нічного зору",
  "item.minecraft.splash_potion.effect.oozing": "Метальний зварок слїзистости",
  "item.minecraft.splash_potion.effect.poison": "Метальний зварок втроєнє",
  "item.minecraft.splash_potion.effect.regeneration": "Метальний зварок відновленє",
  "item.minecraft.splash_potion.effect.slow_falling": "Метальний зварок поволого паданє",
  "item.minecraft.splash_potion.effect.slowness": "Метальний зварок поволости",
  "item.minecraft.splash_potion.effect.strength": "Метальний зварок сили",
  "item.minecraft.splash_potion.effect.swiftness": "Метальний зварок борзости",
  "item.minecraft.splash_potion.effect.thick": "Густий метальний зварок",
  "item.minecraft.splash_potion.effect.turtle_master": "Метальний зварок черепашєчої мочи",
  "item.minecraft.splash_potion.effect.water": "Метальна флєщина з водов",
  "item.minecraft.splash_potion.effect.water_breathing": "Метальний зварок водного диханє",
  "item.minecraft.splash_potion.effect.weakness": "Метальний зварок слабости",
  "item.minecraft.splash_potion.effect.weaving": "Метальний зварок плетенє",
  "item.minecraft.splash_potion.effect.wind_charged": "Метальний зварок вітрєности",
  "item.minecraft.spruce_boat": "Смерековий човен",
  "item.minecraft.spruce_chest_boat": "Смерековий човен з куфром",
  "item.minecraft.spyglass": "Далекоглєд",
  "item.minecraft.squid_spawn_egg": "Яйце появи мутнєка",
  "item.minecraft.stick": "Патик",
  "item.minecraft.stone_axe": "Камнєний топір",
  "item.minecraft.stone_hoe": "Камнєна сапка",
  "item.minecraft.stone_pickaxe": "Камнєний дзюбак",
  "item.minecraft.stone_shovel": "Камнєний рискаль",
  "item.minecraft.stone_spear": "Камнєне копє",
  "item.minecraft.stone_sword": "Камнєний меч",
  "item.minecraft.stray_spawn_egg": "Яйце появи зимника",
  "item.minecraft.strider_spawn_egg": "Яйце появи ходуниска",
  "item.minecraft.string": "Нитка",
  "item.minecraft.sugar": "Цукір",
  "item.minecraft.suspicious_stew": "Дивна зупа",
  "item.minecraft.sweet_berries": "Порічка",
  "item.minecraft.tadpole_bucket": "Путнє з пуголовками",
  "item.minecraft.tadpole_spawn_egg": "Яйце появи пуголовка",
  "item.minecraft.tide_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ворнамент бронї «Филї»",
  "item.minecraft.tipped_arrow": "Замочена стріла",
  "item.minecraft.tipped_arrow.effect.awkward": "Замочена стріла",
  "item.minecraft.tipped_arrow.effect.empty": "Нестворювана замочена стріла",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стріла вогнєвідпори",
  "item.minecraft.tipped_arrow.effect.harming": "Стріла кривди",
  "item.minecraft.tipped_arrow.effect.healing": "Стріла зцїленє",
  "item.minecraft.tipped_arrow.effect.infested": "Стріла зараженє",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стріла невидимости",
  "item.minecraft.tipped_arrow.effect.leaping": "Стріла скакучости",
  "item.minecraft.tipped_arrow.effect.levitation": "Стріла лєвітациї",
  "item.minecraft.tipped_arrow.effect.luck": "Стріла везїнє",
  "item.minecraft.tipped_arrow.effect.mundane": "Замочена стріла",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стріла нічного зору",
  "item.minecraft.tipped_arrow.effect.oozing": "Стріла слїзистости",
  "item.minecraft.tipped_arrow.effect.poison": "Стріла втроєнє",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стріла відновленє",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стріла поволого паданє",
  "item.minecraft.tipped_arrow.effect.slowness": "Стріла поволости",
  "item.minecraft.tipped_arrow.effect.strength": "Стріла сили",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стріла борзости",
  "item.minecraft.tipped_arrow.effect.thick": "Замочена стріла",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стріла черепашєчої мочи",
  "item.minecraft.tipped_arrow.effect.water": "Стріла пелесканє",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стріла водного диханє",
  "item.minecraft.tipped_arrow.effect.weakness": "Стріла слабости",
  "item.minecraft.tipped_arrow.effect.weaving": "Стріла плетенє",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Стріла вітрєности",
  "item.minecraft.tnt_minecart": "Візок з динамітом",
  "item.minecraft.torchflower_seeds": "Насїнє смолоцьвітника",
  "item.minecraft.totem_of_undying": "Бовван невмиранє",
  "item.minecraft.trader_llama_spawn_egg": "Яйце появи лями гендлєра",
  "item.minecraft.trial_key": "Ключ стрібувань",
  "item.minecraft.trident": "Ґралї",
  "item.minecraft.tropical_fish": "Тропічна риба",
  "item.minecraft.tropical_fish_bucket": "Путнє з тропічнов рибов",
  "item.minecraft.tropical_fish_spawn_egg": "Яйце появи тропічної риби",
  "item.minecraft.turtle_helmet": "Панцир черепахи",
  "item.minecraft.turtle_scute": "Дощинка черепахи",
  "item.minecraft.turtle_spawn_egg": "Яйце появи черепахи",
  "item.minecraft.vex_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ворнамент бронї «Янтипко»",
  "item.minecraft.vex_spawn_egg": "Яйце появи янтипка",
  "item.minecraft.villager_spawn_egg": "Яйце появи селєнина",
  "item.minecraft.vindicator_spawn_egg": "Яйце появи махабунди",
  "item.minecraft.wandering_trader_spawn_egg": "Яйце появи вандрівного гендлєрє",
  "item.minecraft.ward_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ворнамент бронї «Наглєдач»",
  "item.minecraft.warden_spawn_egg": "Яйце появи наглєдника",
  "item.minecraft.warped_fungus_on_a_stick": "Покручена губа на патику",
  "item.minecraft.water_bucket": "Путнє води",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ворнамент бронї «Вандрівник»",
  "item.minecraft.wheat": "Пшеницє",
  "item.minecraft.wheat_seeds": "Насїнє пшеницї",
  "item.minecraft.white_bundle": "Біле міщє",
  "item.minecraft.white_dye": "Білий барвник",
  "item.minecraft.white_harness": "Білий хомут",
  "item.minecraft.wild_armor_trim_smithing_template": "Ковальский шєбльон",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ворнамент бронї «Дикість»",
  "item.minecraft.wind_charge": "Вихрик",
  "item.minecraft.witch_spawn_egg": "Яйце появи відьми",
  "item.minecraft.wither_skeleton_spawn_egg": "Яйце появи відер-шкілєта",
  "item.minecraft.wither_spawn_egg": "Яйце появи відера",
  "item.minecraft.wolf_armor": "Вовча збруя",
  "item.minecraft.wolf_spawn_egg": "Яйце появи вовка",
  "item.minecraft.wooden_axe": "Деревлєний топір",
  "item.minecraft.wooden_hoe": "Деревлєна сапка",
  "item.minecraft.wooden_pickaxe": "Деревлєний дзюбак",
  "item.minecraft.wooden_shovel": "Деревлєний рискаль",
  "item.minecraft.wooden_spear": "Деревлєне копє",
  "item.minecraft.wooden_sword": "Деревлєний меч",
  "item.minecraft.writable_book": "Книжка з пером",
  "item.minecraft.written_book": "Написана книжка",
  "item.minecraft.yellow_bundle": "Жовте міщє",
  "item.minecraft.yellow_dye": "Жовтий барвник",
  "item.minecraft.yellow_harness": "Жовтий хомут",
  "item.minecraft.zoglin_spawn_egg": "Яйце появи зоґлїна",
  "item.minecraft.zombie_horse_spawn_egg": "Яйце появи конє-мерцє",
  "item.minecraft.zombie_nautilus_spawn_egg": "Яйце появи кораблика-мерцє",
  "item.minecraft.zombie_spawn_egg": "Яйце появи мерцє",
  "item.minecraft.zombie_villager_spawn_egg": "Яйце появи селєнина-мерцє",
  "item.minecraft.zombified_piglin_spawn_egg": "Яйце появи піґлїна-мерцє"
}
export const hal_ua = items; 
